export default {
  title: 'ПИМИС',
  message: {
    login: 'Пријава',
    logout: 'Одјава'
  },
  login: {
    title: 'Пријава',
    forgottenPassword: 'Заборављена лозинка',
    loginAdAccount: 'МФИН АД',
    loginStandardAccount: 'Пријава на сервис',
    anonymousAccess: 'Анонимни приступ',
    documentation: 'Документација',
    modalInfo: 'Због дуже неактивности или брисања локалног кеша, морате се пријавити поново',
    registrationDesc: 'Уколико ваша организација није регистрована на сервис',
    registrationTitle: 'Сервис ПИМИС'
  },
  documents: {
    download: 'Преузимање документа'
  },
  user: {
    username: 'Корисничко име',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинку',
    email: 'И-мејл',
    firstTimeLogin: 'Пријављујем се први пут',
    passwordForgotten: 'Заборављена лозинка',
    passwordResetLinkSent: 'Линк за поновно постављање лозинке је послат на вашу адресу електронске поште',
    welcome: 'Добродошли'
  },
  sidebar: {
    dashboard: 'Почетна страна',
    administration: 'Администрација',
    manageUsers: 'Корисници',
    viewUsers: 'Преглед корисника',
    viewUserProfile: 'Профил',
    manageOrganizations: 'Организације',
    viewOrganizations: 'Преглед организација',
    createUser: 'Креирање корисника',
    registry: 'Шифарници',
    reports: 'Извештаји',
    registryOrganizations: 'Организације',
    subscribe: 'Претплата на шифарнике',
    createSubscribe: 'Претплата',
    manageSubscribe: 'Преглед',
    manageRoles: 'Управљање улогама',
    viewRoles: 'Преглед улога',
    createRole: 'Креирање улоге',
    projects: 'Пројекти',
    projectLists: 'Листе пројеката',
    registries: 'Шифарници',
    createProject: 'Креирање пројекта',
    viewProjects: 'Преглед пројеката',
    viewProjectsArchived: 'Преглед архивираних пројеката',
    manageProjects: 'Управљање пројектима',
    createProjectList: 'Креирање листе пројеката',
    viewProjectLists: 'Преглед листе пројеката',
    manageProjectLists: 'Управљање листама пројеката',
    projectDetails: 'Детаљи пројекта',
    projectRevisionDetails: 'Детаљи ревизије пројекта',
    projectPhases: 'Фазе пројекта',
    projectOptions: 'Опције пројекта',
    projectDocuments: 'Документи пројекта',
    projectOptionsAppropriations: 'Апропријације пројекта',
    projectOptionsOrganizations: 'Посматрачи пројекта',
    formPifMini: 'ПИФ мини',
    formPreImplementation: 'Припрема',
    formPlan: 'План',
    formQuarterly: 'Квартални',
    formRationalization: 'Рационализација',
    formCorrection: 'Корекција',
    formQuarterlyCorrection: 'Квартални корекција',
    formConclusion: 'Закључак',
    formEffects: 'Екс-пост',
    formIdea: 'Идеја',
    formImportant: 'Посебан',
    formPreparedness: 'Спремност',
    formProjectIdentification: 'Предлог КП',
    viewUserDetails: 'Детаљи корисника',
    viewRoleDetails: 'Детаљи улоге',
    viewOrganizationDetails: 'Детаљи организацијe',
    viewProjectListDetails: 'Детаљи листе пројеката'
  },
  contextPath: {
    administration: 'Администрација',
    organization: 'Преглед организација',
    table: 'Шифарник',
    role: 'Преглед улога',
    row: 'Слог',
    Demo: 'Демо',
    projects: 'Преглед пројеката',
    'projects-archived': 'Преглед архивираних пројеката',
    'project-lists': 'Листе пројеката',
    project: 'Детаљи пројекта',
    pif: 'ПИФ',
    unospif: 'Унос ПИФ',
    odobrenjeop: 'Одобрење ОП',
    ocene: 'Оцене',
    presel: 'Пре-селекција',
    preselrk: 'Пре-селекција РК',
    form: 'Образац',
    phases: 'Фазе',
    stages: 'Етапе',
    documents: 'Документа',
    options: 'Опције',
    details: 'Детаљи',
    organizations: 'Посматрачи',
    appropriations: 'Апропријације',
    dashboard: 'Почетна страна',
    registry: 'Шифарници',
    150: 'ПИФ Упутство',
    151: 'ПИФ 1.5.1',
    152: 'ПИФ 1.5.2',
    153: 'ПИФ 1.5.3',
    154: 'ПИФ 1.5.4',
    155: 'ПИФ 1.5.5',
    user: 'Преглед корисника',
    archive: 'Архивирај пројекат',
    unarchive: 'Деархивирај пројекат',
    archiveQuestionTest: 'Потврдите архивирање пројекта',
    archiveSuccess: 'Успешно сте архивирали пројекат',
    archiveError: 'Грешка при архивирању пројекта',
    editSuccess: 'Успешно сте изменили податке'

  },
  userStatuses: {
    0: 'Сви',
    1: 'Активан',
    2: 'Неактиван',
    3: 'Опозван',
    4: 'Деактивиран'
  },
  tabulator: {
    ajax: {
      loading: 'Учитавам', // ajax loader text
      error: 'Грешка' // ajax error text
    },
    groups: { // copy for the auto generated item count in group header
      item: 'ставка', // the singular  for item
      items: 'ставке' // the plural for items
    },
    pagination: {
      page_size: 'Редова по страни:', // label for the page size select element
      first: 'Прва', // text for the first page button
      first_title: 'Прва страна', // tooltip text for the first page button
      last: 'Последња',
      last_title: 'Последња страна',
      prev: 'Претходна',
      prev_title: 'Претходна страна',
      next: 'Следећа',
      next_title: 'Следећа страна'
    },
    headerFilters: {
      default: 'филтрирај', // default header filter placeholder text
      columns: {
        name: 'филтрирај име' // replace default header filter text for column name
      }
    },
    emptyTable: 'Нема информација',
    totalElements: 'Укупно редова: '
  },
  markdown: {
    bold: 'Подебљана слова',
    italic: 'Укошена слова',
    strikethrough: 'Подвучена слова',
    'heading-1': 'Велики наслов',
    'heading-2': 'Средњи наслов',
    'heading-3': 'Мали наслов',
    code: 'Уоквири',
    quote: 'Цитирај',
    'unordered-list': 'Ознаке за набрајање',
    'ordered-list': 'Бројеви за набрајање',
    link: 'Додај линк',
    image: 'Додај слику',
    table: 'Додај табелу',
    'horizontal-rule': 'Додај хоризонталну линију',
    preview: 'Преглед',
    fullscreen: 'Цео екран',
    help: 'Помоћ',
    sideBySide: 'Двоструки преглед',
    column: 'Колона',
    text: 'Текст'
  },
  roles: {
    Administrator: 'Администратор',
    Operator: 'Оператер сервиса',
    Reviewer: 'Преглед свих шифарникa',
    Operator_Description: 'Оператер управе за трезор са овлашћењима креирања приступа систему новим правним лицима/органима',
    Local_Admin: 'Локални администратор',
    Local_Admin_Description: 'Администрација правних лица/органа',
    Local_User: 'Локални корисник',
    Local_Power_User: 'Локални корисник (КППЗ)',
    Local_Verification_User: 'Локални корисник верификатор',
    Local_User_Description: 'Локални корисник правног лица/органа',
    Evaluator: 'Оцењивач',
    Evaluator_Description: 'Оцењивач пројекта',
    Integration: 'Интеграција',
    Integration_Description: 'Корисник за интеграцију са овлашћењем ажурирања шифарника',
    Refresh_Token: 'Освежавање токена',
    Demo: 'Шифарник демо',
    SourceOfFunding: 'Шифарник извора финансирања',
    PaymentCode: 'Шифарник шифара плаћања',
    Country: 'Шифарник држава',
    Bank: 'Шифарник банака',
    Currency: 'Шифарник валута',
    Function: 'Шифарник функција',
    EconomicClassification: 'Шифарник економских класификација',
    Municipality: 'Шифарник општина',
    BudgetUser: 'Шифарник буџетских корисника'
  },
  claims: {
    Admin: 'Администрација',
    Admin_description: 'Све функционалности у систему (администрација)',
    Organization_RegistrationResolve: 'Управљање регистрацијом организација',
    Organization_RegistrationResolve_description: 'Одобравање и отказивање захтева за регистрацију организације (администрација)',
    Organization_View: 'Преглед организација',
    Organization_View_description: 'Преглед детаља организације (администрација)',
    Organization_Manage: 'Ажурирање организације',
    Organization_Manage_description: 'Ажурирање скраћеног назива организације (администрација)',
    Role_Manage: 'Управљање корисничким улогама',
    Role_Manage_description: 'Креирање, измена и брисање апликативних улога у оквиру сопствене организације',
    Role_View: 'Преглед корисничких улога',
    Role_View_description: 'Преглед апликативних улога у оквиру сопствене организације',
    User_Manage: 'Управљање корисницима',
    User_Manage_description: 'Креирање и измена корисника у оквиру сопствене организације',
    User_Review: 'Преглед корисника система',
    User_Review_description: 'Преглед свих корисника система (администрација)',
    User_StatusUpdate: 'Опозив корисника',
    User_StatusUpdate_description: 'Опозив и реактивација права приступа кориснику у оквиру сопствене организације',
    User_StatusUpdateAll: 'Блокада корисника',
    User_StatusUpdateAll_description: 'Блокада и реактивација права приступа кориснику у оквиру система (администрација)',
    User_UpdateAll: 'Ажурирање корисника система',
    User_UpdateAll_description: 'Ажурирање корисника система без могућности креирања (администрација)',
    User_View: 'Преглед корисника',
    User_View_description: 'Преглед корисника у оквиру сопствене организације',
    Project_View: 'Преглед пројекта',
    Project_View_description: 'Преглед листе и детаља пројеката у складу са организационим правима',
    Project_Manage: 'Управљање пројектом',
    Project_Manage_description: 'Креирање и измена пројеката у оквиру сопствене организације',
    Form_Manage: 'Ажурирање образаца',
    Form_Manage_description: 'Ажурирање образаца у оквиру сопствене организације',
    Form_ConfirmationResolve: 'Потврда образаца',
    Form_ConfirmationResolve_description: 'Потврда образаца у оквиру сопствене организације',
    Form_ApprovalResolve: 'Одобрење образаца',
    Form_ApprovalResolve_description: 'Одобрење свих образаца у систему (администрација)',
    Project_ListManage: 'Ажурирање листи пројеката',
    Project_ListManage_description: 'Ажурирање листа пројеката у систему (администрација)',
    Project_ListView: 'Преглед листи пројеката',
    Project_ListView_description: 'Преглед свих листа пројеката у систему (администрација)',
    Registry_Manage: 'Ажурирање шифарника',
    Registry_Manage_description: 'Ажурирање шифарника у систему (администрација)',
    DMS_Manage: 'Управљање документима пројекта',
    DMS_Manage_description: 'Додавање, брисање и измена докумената пројекта',
    Form_ImportantManage: 'Ажурирање образаца од посебног значаја',
    Form_ImportantManage_description: 'Ажурирање образаца од посебног значаја',
    Project_Idea_Verification: 'Сагласност идеје',
    Project_Idea_Verification_description: 'Даје сагласност за идеју',
    Project_Idea_Approval: 'Одобрење идеје',
    Project_Idea_Approval_description: 'Даје одобрење за идеју',
    Project_Idea_Minister_Approval: 'Идеја - одобрење министра',
    Project_Idea_Minister_Approval_description: 'Одобрење идеје као министар',
    Project_Send_Ministry: 'Пошаљи министру',
    Project_Send_Ministry_description: 'Одобрење да се пошаље министру на потврду',
    Minister: 'Министар',
    Minister_description: 'Дозвола за потпис као министар',
    Mei_Approval_Comment_Send: 'Слање МЕИ на оцену',
    Mei_Approval_Comment_Send_description: 'Дозвола за слање МЕИ на оцену',
    Mei: 'МЕИ',
    Mei_description: 'Преглед пројеката који захтевају МЕИ оцену',
    Send_Request_Change_Form: 'Захтев за измену',
    Send_Request_Change_Form_description: 'Дозвола за слање захтева за изменом обрасца'
  },
  general: {
    phone: 'Број телефона',
    email: 'Адреса електронске поште',
    supportPhoneNumbers: 'Опциона листа телефона за подршку',
    supportEmails: 'Опциона листа еМаил адреса за подршку',
    enterSupportPhones: 'Унесите листу бројева телефона за подршку. Сепаратор може бити зарез, тачка-зарез или празно место, као и њихова комбинација (нпр. 064111111, 064222222).',
    enterSupportEmails: 'Унесите листу еМаил адреса за подршку. Сепаратор може бити зарез, тачка-зарез или празно место, као и њихова комбинација (нпр. mail1@test.rs, mail2@test.rs).',
    changelog: 'Информације о верзијама сервиса',
    technicalSupport: 'Пријава проблема',
    undefined: '-',
    filters: 'филтери',
    clearAllFilters: 'Поништи све',
    details: 'Детаљи'
  },
  bool: {
    yes: 'Да',
    no: 'Не'
  },
  registration: {
    title: 'Регистрација организације',
    registrationForbidden: 'Регистрација организације није дозвољена у овом тренутку',
    legalEntityInfo: 'Подаци о организацији',
    legalEntityCheckboxText: 'Региструјем се као ПРИВАТНО ПРАВНО ЛИЦЕ',
    budgetUserIdNote: 'Укуцајте првих неколико бројева ЈБКЈС-а или првих неколико карактера назива и систем ће приказати предлоге',
    budgetUserId: 'ЈБКЈС',
    budgetUserIdAsterisk: 'ЈБКЈС*',
    budgetNumberFootnote: '*Попуњава организација које има додељен ЈБКЈС',
    organizationProjects: 'Пројекти који припадају изабраној организацији и није тренутно изабрани пројекат',
    noOrganizationProjects: 'Нема пројеката за изабрану организацију',
    companyNumber: 'Матични број',
    companyNumberShort: 'МБ',
    taxIdNumber: 'ПИБ',
    treasury: 'Шифра трезора',
    parentCompany: 'Надређена институција',
    companyName: 'Назив организације',
    legalEntityName: 'Име јавног предузећа',
    executionAccount: 'Рачун извршења буџета (без размака и цртица)',
    executionAccountNoDesc: 'Рачун извршења буџета',
    address: 'Адреса седишта',
    postalCode: 'Поштански број',
    treasuryBranchInfo: 'Подаци o организационој јединици Управе за Tрезор',
    treasuryBranch: 'Број организационе јединице',
    treasuryBranchNote: 'укуцајте првих неколико слова града/општине и систем ће приказати предлоге',
    email: 'Адреса електронске поште',
    adminInfo: 'Подаци о администратору',
    name: 'Име и презиме',
    personalIdentityNumber: 'ЈМБГ',
    identityNumber: 'Број личне карте',
    submit: 'Пошаљи захтев за регистрацију',
    infoText: 'Након успешно поднетог захтева, добићете и-мејл поруку са детаљима процедуре за комплетирање процеса регистрације',
    registrationSuccess: 'Регистрација успешно обављена',
    registrationSuccessText: 'Успешно сте обавили регистрацију на сервис КИБЈЛС',
    registrationSuccessConfirmation: 'Проверите да ли сте добили потврдни и-мејл од ПИМИС сервиса. Уколико потврда није стигла, запишите податке са овог обавештења и преузмите регистрациони налог кликом на дугме \'Преузимање захтева\'',
    registrationLimitExceeded: 'Прекорачили сте број сукцесивних захтева за регистрацију, молимо сачекајте 10 секунди па покушајте поново',
    printRequestForm: 'Преузимање захтева',
    printForm: 'Преузимање потврде',
    ouList: 'Листа организационих јединица',
    editRegistration: 'Уколико желите да измените већ поднету регистрацију, притисните дугме <strong>Учитај регистрацију</strong> и унесите токен за измену регистрације како бисте учитали регистроване податке.',
    editRegistrationLine2: 'Након унетих измена, сачувајте их притиском на дугме <strong>Пошаљи захтев за регистрацију</strong>',
    editRegistrationButton: 'Измени регистрацију',
    editRegistrationToken: 'Токен за измену регистрације',
    editRegistrationLoad: 'Учитавање података за измену',
    registrationLoad: 'Учитај регистрацију',
    registrationRequestLine1: 'Ваш захтев је евидентиран за ЈБКЈС',
    registrationRequestLine2: 'у Филијали',
    registrationRequestLine3: 'Адреса',
    registrationRequestLine4: 'Број телефона',
    registrationRequestId: 'Ваш захтев је евидентиран под бројем',
    registrationRequestTreasury: 'у филијали',
    registrationRequestDocumentation: 'Документација коју подносите је наведена на веб адреси',
    copyToClipboard: 'Копирај токен за измену регистрације',
    createdDate: 'Датум регистрације'
  },
  registry: {
    оrganizationsDescription: 'Преглед корисника јавних средстава',
    organizationId: 'ЈБКЈС',
    organizationName: 'Назив',
    organizationCompanyNumber: 'МБ',
    organizationTaxIdNumber: 'ПИБ',
    organizationAddress: 'Адреса',
    organizationPlace: 'Место',
    organizationTreasury: 'Trezor',
    organizationTreasuryBranchCode: 'Филијала трезора',
    organizationPhoneNumber: 'Број телефона',
    organizationEmail: 'Електронска пошта',
    organizationActivity: 'Активност',
    organizationType: 'Тип'
  },
  profile: {
    details: 'Детаљи корисничког налога',
    change: 'Измена корисничког налога',
    rolesAndClaims: 'Корисничке улоге и овлашћења',
    role: 'Корисничка улога',
    status: 'Статус корисника',
    name: 'Име и Презиме',
    email: 'Електронска пошта',
    edit: 'Промени',
    login: 'Корисничко име',
    success: 'Успешно сте променили информације корисника',
    successPrivilege: 'Успешно сте променили овлашћења корисника',
    description: 'Опис корисничке улоге',
    statusRestore: 'Успешно сте опозвали корисника',
    statusActivate: 'Успешно сте активирали корисника',
    revokeDate: 'Датум',
    revokeLogin: 'Променио',
    revokeComment: 'Коментар опозива',
    systemRolesAndClaims: 'Системске привилегије',
    dataTablesRolesAndClaims: 'Привилегије табела података',
    BasicInformation: 'Основне информације',
    roles: 'Корисничке улоге',
    claims: 'Корисничка овлашћења',
    personalSettings: 'Лична подешавања',
    csvDelimiter: 'CSV раздвајач',
    successChangePersonalSettings: 'Успешно сте променили лична подешавања',
    loginAd: 'Ад кориснички налог',
    phoneNumber: 'Број телефона'
  },
  successKeyIndicator: {
    ok: 'ОК',
    inactivity: 'НЕАКТИВАН',
    limitReached: 'ВАН ГРАНИЧНЕ ВРЕДНОСТИ',
    timeToProjectImplementationShortDesc: 'ВДР',
    inactivityShortDesc: 'Неактивност',
    fundingAdequacyIndicatorShortDesc: 'ПАФ',
    calculate: 'Израчунај',
    reset: 'Ресетуј'
  },
  status: {
    Active: 'Активан',
    Inactive: 'Неактиван',
    Revoked: 'Опозван',
    RevokedAccess: 'Опозван приступ'
  },
  form: {
    date: 'Датум',
    ok: 'У реду',
    cancel: 'Одустани',
    submit: 'Потврди',
    send: 'Пошаљи',
    validate: 'Валидирај форму',
    mark: 'Оцени',
    markAndLock: 'Оцени и закључај',
    close: 'Затвори',
    save: 'Сачувај',
    saveAndLock: 'Сачувај и закључај',
    lock: 'Закључај',
    unlock: 'Откључај',
    apply: 'Примени',
    edit: 'Измени',
    register: 'Региструј се',
    errors: 'Грешке',
    warnings: 'Упозорења',
    warning: 'Упозорење',
    notification: 'Обавештење',
    load: 'Учитај',
    saveToFile: 'Сачувај у фајл',
    saveToDiagnosticFile: 'Сачувај у дијагностички фајл',
    saveToClipboard: 'Сачувај у клипборд',
    capsLockOn: 'Укључен је CapsLock',
    activate: 'Активирај',
    approve: 'Одобри',
    revoke: 'Опозови',
    saveSubscription: 'Сачувај претплату',
    add: 'Унос',
    update: 'Ажурирај',
    success: 'Успешно сте извршили акцију',
    delete: 'Обриши',
    export: 'Извоз',
    exportToCsv: 'Извоз у цсв',
    exportToJson: 'Извоз у јсон',
    exportToPdf: 'Извоз у пдф',
    import: 'Увоз',
    importJson: 'Увези јсон фајл',
    notChangedForm: 'Морате променити бар једно поље',
    sendActivationEmail: 'Пошаљи активациони е-маил',
    yes: 'Да',
    no: 'Не',
    return: 'Врати на допуну',
    approvePhase: 'Потврди етапу',
    approveQaurter: 'Потврди квартал',
    stopped: 'Рационализација - Гашење',
    postponed: 'Рационализација - Одлагање',
    correction: 'Корекција',
    correctionApproved: 'Корекција прихваћена',
    correctionAmendment: 'Корекција допуна',
    addNewQaurter: 'Да и додај нови квартал',
    addNewPhase: 'Да и пређи на следећу фазу',
    validation: 'Валидација',
    commissionDecisionDateControlText: 'Унесите датум заседања комисије',
    postponedDateControlText: 'Унесите датум до када се одлаже пројекат',
    actions: {
      rationalizationProposal: 'Предлог за рационализацију',
      rationalizationCorrectionProposal: 'Предлог за поновну корекцију',
      sendToCommission: 'Слање листе комисији',
      commissionDecision: 'Одлука комисије',
      planCorrection: 'Корекција плана',
      cancelPreImplementation: 'Откажи пројекат',
      successKeyIndicator: 'КПУ',
      idea: 'Слање идеје на листу',
      correction: 'Слање предлога корекције на листу',
      important: 'Пројекат од Пос-значаја',
      verificationSend: 'Пошаљи на сагласност',
      verification: 'Сагласност',
      ministerApprovalSend: 'Пошаљи на потврду министра',
      ministerApproval: 'Потврда министра',
      meiApprovalCommentSend: 'Пошаљи МЕИ на прелиминарну оцену',
      meiApprovalComment: 'Потврда прелиминарне оцене',
      returnFormForUpdate: 'Врати образац на допуну',
      sendFormForUpdate: 'Пошаљи захтев за допуну образца',
      projectIdentification: 'Слање предлога пројекта на листу',
      preparedness: 'Слање спремности пројекта на листу',
      ideaCommissionDecision: 'Одлука комисије за идеју пројекта',
      projectIdentificationCommissionDecision: 'Одлука комисије за идентификацију пројекта',
      preparednessCommissionDecision: 'Одлука комисије за спремност пројекта',
      correctionCommissionDecision: 'Одлука комисије за корекцију пројекта',
      openCorrection: 'Пошаљи пројекат на корекцију',
      updateImportant: 'Ажурирај',
      approveImportant: 'Потврди',
      '00': 'Потврди квартал',
      '01': 'Пошаљи на одобрење',
      '012': 'Потврди квартал',
      '02': 'Одобри',
      '03': 'Потврди',
      '020': 'Сагласност',
      '022': 'Потврди',
      11: 'Пошаљи на одобрење',
      12: 'Одобри',
      13: 'Потврди',
      21: 'Пошаљи на одобрење',
      22: 'Одобри',
      23: 'Потврди',
      31: 'Пошаљи на одобрење',
      32: 'Одобри',
      33: 'Потврди',
      312: 'Потврди квартал',
      313: 'Одобри квартал',
      41: 'Пошаљи на одобрење',
      42: 'Одобри',
      43: 'Потврди',
      51: 'Пошаљи на одобрење',
      52: 'Одобри',
      53: 'Потврди',
      61: 'Пошаљи на одобрење',
      62: 'Одобри',
      63: 'Потврди',
      71: 'Пошаљи на одобрење',
      72: 'Одобри',
      73: 'Потврди',
      81: 'Пошаљи на одобрење',
      82: 'Одобри',
      83: 'Потврди',
      512: 'Потврди квартал',
      513: 'Одобри квартал',
      111: 'Пошаљи на одобрење',
      112: 'Одобри',
      113: 'Потврди',
      1129: 'Пошаљи на одобрење',
      1133: 'Одобри',
      1134: 'Потврди',
      121: 'Пошаљи на одобрење',
      122: 'Одобри',
      123: 'Потврди'
    },
    importText1: 'Приказани текст представља текући образац у JSON формату.',
    importText2: 'JSON je овде могуће мењати директно или га заменити учитавањем JSON фајла.',
    name: {
      0: 'Образац за прелиминарну оцену пројектних идеја',
      1: 'Образац за оцену предлога пројекта',
      2: 'Извештај о спремности капиталног пројекта'
    },
    description: {
      0: `Образац за прелиминарну оцену пројектних идеја је образац на којем се подноси почетни предлог идеје републичког капиталног пројекта.

Значај овог обрасца огледа се у идентификацији почетне идеје капиталног пројекта, чијом би се реализацијом, са аспекта овлашћеног предлагача, остварила добробит за Републику Србију, односно за једну или више јединица локалне самоуправе (општину, град или град Београд).

Имајући у виду наведено, приликом попуњавања предметног обрасца потребно је јасно дефинисати:
 - Назив пројектне идеје;
 - Прелиминарну процену трошкова капиталног пројекта (трошкови припреме и реализације пројекта);
 - Прелиминарну процену трајања капиталног пројекта (припрема пројекта и реализација пројекта);
 - Везу са документима развојног планирања, документима јавних политика и осталим планским документима;
 - Потенцијалне изворе финансирања (припреме пројекта и реализација пројекта).

**Напомена**: Приликом сачињавања овог обрасца није нужно да наведени показатељи буду дефинитивно идентификовани будући да се они могу мењати односно допуњавати током касније припреме пројектне идеје. Потребно је да унети подаци пруже довољан ниво информација о релевантности пројектне идеје у односу на аспекте дефинисане чланом 13. Уредбе о капиталним пројектима како би на адекватан начин могла да буде предмет предселекције и даље оцене. Нарочито треба обратити пажњу да подаци о пројекту могу да укажу на утицај пројекта на животну средину, однос и допринос пројекта прилагођавању или ублажавању измењеним климатским условима, све у складу са важећим међународним споразумима, стратешким и другим документима и прописима из области заштите животне средине, односа према измењеним климатским условима, енергетској и зеленој транзицији и одрживом економском развоју и однос према другим документима и стратешким опредељењима Републике Србије који чине део правног оквира и који су важећи у тренутку подношења овог обрасца.

Одредбама Правилника о пројектној документацији прописано је да лице које је на основу закона и других прописа овлашћено да заступа и представља Овлашћеног предлагача, потписује предметни образац и гарантује за тачност у њему наведених података.`,
      1: `Образац за  оцену предлога пројекта је образац на којем се подноси предлог пројекта и који служи за анализу стратешке релевантности, финансијског и реализационог аспекта предлога пројекта.

Значај овог обрасца огледа се у идентификацији предлога пројекта, чијом би се реализацијом, са аспекта овлашћеног предлагача, остварила добробит за Републику Србију, аутономну покрајину односно за једну или више јединица локалне самоуправе.

Имајући у виду наведено, а ради прецизне идентификације предлога пројекта, приликом попуњавања овог обрасца потребно је јасно дефинисати циљеве предлога пројекта, циљне групе, предвиђене трошкове, негативне утицаје, очекиване резултате,  ризике, као и платформу за умањење предвиђених потенцијалних ризика.

За пројекте за које се планира финансирање или суфинансирање из средстава Европске уније, овлашћени предлагач је у обавези да приликом подношења овог обрасца приложи и исход оцењивања из ИСДАКОН-а.

**Напомена**: Приликом сачињавања овог обрасца није нужно да наведени показатељи буду дефинитивно идентификовани будући да се они могу мењати односно допуњавати током припреме пројекта за реализацију.
Такође, потребно да овлашћени предлагач приликом уноса података пружи довољан ниво информација о релевантности предлога пројекта у односу на аспекте дeфинисане чланом 13. Уредбе o капиталним пројектима како би на адекватан начин могао да буде предмет даље оцене.
Нарочито треба обратити пажњу да подаци о пројекту могу да укажу на утицај пројекта на животну средину, однос и допринос пројекта прилагођавању или ублажавању измењеним климатским условима, све у складу са важећим међународним споразумима, стратешким и другим документима и прописима из области заштите животне средине, односа према измењеним климатским условима, енергетској и зеленој транзицији и одрживом економском развоју и однос према другим документима и стратешким опредељењима Републике Србије који чине део правног оквира и који су важећи у тренутку подношења овог обрасца.

Део текста који је написан закошеним („италикˮ) фонтом представља упутство за попуњавање овог обрасца, а које се током попуњавања може обрисати или искористити за боље појашњење предлога пројекта.

Одредбама Правилника о пројектној документацији прописано је да лице које је на основу закона и других прописа овлашћено да заступа и представља Овлашћеног предлагача, потписује предметни образац и гарантује за тачност у њему наведених података.

Oбразац за оцену предлога пројекта је подељен на одељке у којима се наводе:
1. Опште информације и подаци са описом предлога пројекта;
2. Подаци од значаја за одређивање прихватљивости предлога пројекта;
3. Подаци о релевантности предлога пројекта;
4. Подаци о финансијском аспекту предлога пројекта;
5. Подаци о реализационом аспекту предлога пројекта (аспекту реализације).`,
      2: `Извештај о спремности капиталног пројекта (у даљем тексту: Извештај) служи за прибављање додатних информација и података ради утврђивања нивоа припремљености постојеће пројектне документације односно ради процене спремности пројекта за финансирање и реализацију.

Узимајући у обзир специфичности конкретног капиталног пројекта, потребно је попунити сва поља у одељцима Извештаја, и приложити документацију у складу са Уредбом о капиталним пројектима.

Поља која се не односе на Овлашћеног предлагача у конкретном случају (у зависности од природе пројекта или из других разлога) не попуњавају се.

За пројекте за које се планира финансирање или суфинансирање из средстава Европске уније, овлашћени предлагач је у обавези да приликом подношења овог обрасца приложи и исход оцењивања из ИСДАКОН-а.

Извештај је потребно попунити стручно, одговорно и савесно. Извештај треба да пружи адекватан ниво информација и документације како би пројекат био оцењен и одабран на основу његове релевантности у односу на циљеве и аспекте дефинисане Уредбом, посебно у односу на аспекте прописане чланом 13. Уредбе. Приликом сачињавања овог Извештаја нарочито треба обратити пажњу да пројекти буду сагледани и оцењени у погледу утицаја пројекта на животну средину, односа и доприноса пројекта прилагођавању или ублажавању измењеним климатским условима, у складу са важећим међународним споразумима, стратешким и другим документима из области заштите животне средине, односа према измењеним климатским условима, зеленој транзицији и другим документима и стратешким опредељењима Републике Србије који чине део правног оквира и који су важећи у тренутку подношења овог Извештаја.

Одредбама Правилника о пројектној документацији прописано је да лице, које је на основу закона и других прописа овлашћено да заступа и представља Овлашћеног предлагача, потписује Извештај и гарантује за тачност у њему наведених података.

Део текста који је написан закошеним („италикˮ) фонтом представља упутство за попуњавање овог обрасца, а које се током попуњавања може обрисати или искористити за боље појашњење предлога пројекта.

Извештај је подељен на одељке у којима се наводе:
1. општи подаци о пројекту и овлашћеном предлагачу и опис пројекта;
2. подаци за идентификацију  пројекта;
3. подаци о техничком аспекту пројекта;
4. подаци о институционалним карактеристикама и институционалном аспекту пројекта;
5. подаци о економско-финансијском аспекту пројекта;
6. подаци од значаја за оцену утицаја пројекта на животну средину;
7. подаци о прелиминарним ризицима пројекта;
8. сажет приказ/резиме наведених података са прелиминарном оценом овлашћеног предлагача о степену спремности пројекта.`
    }
  },
  activation: {
    title: 'Активација корисника',
    success: 'Корисник успешно активиран',
    activationSent: 'Уколико је корисничко име исправно линк за активацију корисника биће послат на вашу адресу електронске поште'
  },
  reset: {
    title: 'Постављање лозинке',
    success: 'Корисничка лозинка успешно постављена'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Дошло је до грешке. Проверите списак грешака испод',
    missingConclusionReport: 'КП изв.',
    token: {
      refreshTokenExpired: 'Обновљиви токен је истекао',
      failedToRefreshToken: 'Грешка приликом добијања приступног токена након освежавања'
    }
  },
  autocomplete: {
    completeSearchMessage: 'Унети критеријум \'{query}\' задовољава више од {limit} резултата. Сузите критеријум или наставите претрагу на {url}',
    urlText: 'списку КЈС',
    noItemsFound: 'Нема резултата за задате критеријуме претраге'
  },
  dropzone: {
    defaultMessage: 'Превуците датотеку у уоквирени део или кликните за дијалог',
    allowedFormats: 'Дозвољени фајлови типа: ',
    unsupportedFile: 'Недозвољен тип фајла!',
    tooManyFiles: 'Превукли сте више од дозвољеног броја фајлова',
    unmatchedClosingTag: 'Недостаје отварајући таг',
    unexpectedClosingTag: 'Неочекивани затварајући таг',
    unknownError: 'Непозната грешка у документу'
  },
  userAdministration: {
    description: 'Управљање корисничким налозима и сигурносним привилегијама',
    userManagementDescription: 'Преглед и управљање постојећим корисницима сервиса',
    userCreateDescription: 'Додавање новог корисничког налога за рад на сервису',
    roleManagementDescription: 'Преглед и управљање корисничким улогама и привилегијама',
    organizationManagementDescription: 'Преглед и управљање организацијама, одобравање и отказивање захтева за регистрацијом у систему',
    roleCreateDescription: 'Креирање нове корисничке улоге у систему',
    userDetails: 'Детаљи корисничког налога',
    userLogin: 'Корисничко име',
    userLoginAd: 'Ад кориснички налог',
    userName: 'Име и презиме',
    userStatus: 'Статус корисника',
    email: 'Електронска пошта',
    name: 'Име',
    organizationName: 'Организација',
    administration: 'Управљање корисницима',
    localAdministration: 'Управљање локалним корисницима',
    localUserRoles: 'Корисничке улоге',
    localUserClaims: 'Корисничка овлашћења',
    roleClaims: 'Корисничка овлашћења улоге',
    apply: 'Примени',
    userCreateConfirmation: 'Креирати новог локалног корисника?',
    userGroupCreateConfirmation: 'Да ли желите да креирате нову корисничку групу?',
    createUserSuccessful: 'Успешно сте креирали корисника',
    profileEditPrompt: 'Да ли сте сигурни да желите да измените информације корисника?',
    permissionEditPrompt: 'Да ли сте сигурни да желите да измените овлашћења и улоге корисника?',
    revokePromptTitle: 'Да ли сте сигурни да желите да опозовете корисника?',
    revokePromptPlaceholder: 'Унесите коментар опозива',
    activatePrompt: 'Да ли сте сигурни да желите да активирате корисника?',
    activateTitle: 'Активирање корисника',
    userPasswordRequirement: {
      0: 'Број карактера лозинке није исправан',
      1: 'Лозинка мора садржати бројеве',
      2: 'Лозинка мора садржати велика слова',
      3: 'Лозинка мора садржати симболе'
    },
    userLoginRequirement: {
      0: 'Кориснички налог може садржати латинична слова енглеске абецеде',
      1: 'Кориснички налог може садржати бројеве',
      2: 'Кориснички налог може садржати симболе \'.\' , \'_\' ',
      3: 'Кориснички налог мора почети и завршити се са словом или бројем',
      4: 'Кориснички налог може садржати максимално 32 карактера'
    },
    changePassword: 'Промена лозинке',
    changePersonalInformation: 'Промена личних података',
    personalInformation: 'Лични подаци',
    oldPassword: 'Стара лозинка',
    newPassword: 'Нова лозинка',
    confirmNewPassword: 'Потврди нову лозинку',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинку',
    confirmPasswordFail: 'Нова лозинка се не подудара са потврдом лозинка',
    passwordChanged: 'Нова лозинка успешно постављена',
    createUserPrompt: 'Да ли сте сигурни да желите да креирате корисника?',
    createRolePrompt: 'Да ли сте сигурни да желите да креирате улогу?',
    profile: 'Профил',
    InfoNotSet: 'Нисте унели податке о кориснику',
    userInformationUpdateSuccess: 'Успешно сте изменили информације корисника',
    userRole: 'Корисничка улога',
    userRoleId: 'Идентификатор улоге',
    userRoleName: 'Назив улоге',
    userRoleDescription: 'Опис улоге',
    userRoleCreatedDate: 'Датум креирања',
    userRoleType: 'Тип улоге',
    userRoleOrganization: 'Организација',
    lastLoginDate: 'Последња пријава',
    createRoleSuccessful: 'Успешно сте креирали корисничку улогу',
    changeRoleDetails: 'Промена података о улози',
    changeRoleClaims: 'Промена корисничких овлашћења улоге',
    deleteRoleTitle: 'Брисање корисничке улоге',
    deleteRoleMessage: 'Да ли сте сигурни да желите да обришете корисничку улогу?',
    updateRoleSuccessful: 'Успешно сте изменили улогу',
    deleteRoleSuccessful: 'Успешно сте обрисали улогу',
    notifyUser: 'Обавести корисника о креираном корисничком налогу',
    additionalSettings: 'Додатна подешавања',
    userRoleInformation: 'Основне информације о улози',
    userInformation: 'Основне информације о кориснику',
    revokeText: 'Након опозива корисник више неће бити у могућности да се пријави на систем'
  },
  organizationAdministration: {
    name: 'Назив',
    nameShort: 'Скраћени назив',
    budgetUserId: 'ЈБКЈС',
    registrationDate: 'Датум регистрације',
    legalEntityInfo: 'Подаци о организацији',
    adminName: 'Име и презиме',
    adminLogin: 'Корисничко име администратора',
    adminLoginHint: 'Унесите корисничко име и сачекајте на проверу',
    status: 'Статус',
    registrationId: 'Број захтева',
    registrationFormTitle: 'Захтев за регистрацију',
    printAdminFormTitle: 'Потврда о преузимању корисничког налога',
    registrationToken: 'Токен за измену регистрације',
    companyNumber: 'Матични број',
    companyNumberShort: 'МБ',
    taxIdNumber: 'ПИБ',
    treasury: 'Шифра трезора',
    parentCompany: 'Надређена институција',
    companyName: 'Назив организације',
    legalEntityName: 'Име јавног предузећа',
    executionAccount: 'Рачун извршења буџета (без размака и цртица)',
    executionAccountNoDesc: 'Рачун извршења буџета',
    address: 'Адреса седишта',
    postalCode: 'Поштански број',
    treasuryBranchInfo: 'Подаци o организационој јединици Управе за Tрезор',
    treasuryBranch: 'Број организационе јединице',
    treasuryBranchNote: 'укуцајте првих неколико слова града/општине и систем ће приказати предлоге',
    email: 'Адреса електронске поште',
    adminInfo: 'Подаци о администратору',
    identityNumber: 'Број личне карте',
    approvedUser: 'Корисник који је одобрио налог',
    approvedDate: 'Датум одобрења',
    cancelledUser: 'Корисник који је одбио налог',
    cancelledDate: 'Датум одбијања',
    approvalSuccessful: 'Организација успешно одобрена',
    updateSuccessful: 'Организација успешно ажурирана',
    cancellationSuccessful: 'Организација успешно одбијена',
    statuses: {
      1: 'У току',
      2: 'Одобрена',
      3: 'Одбијена'
    },
    statusNames: {
      PENDING: 'У току',
      APPROVED: 'Одобрена',
      CANCELLED: 'Одбијена'
    },
    adminLoginRequirement: {
      0: 'Корисничко име може садржати латинична слова енглеске абецеде',
      1: 'Корисничко име може садржати бројеве',
      2: 'Корисничко име може садржати симболе \'.\' , \'_\' ',
      3: 'Корисничко име мора почети и завршити се са словом или бројем',
      4: 'Корисничко име може садржати максимално 32 карактера'
    },
    printRegistration: 'Преузимање захтева',
    printAdminForm: 'Потврда о преузимању корисничког налога'
  },
  appropriations: {
    budgetYear: 'Буџетска година',
    organizationCode: 'ЈБКЈС',
    budgetYearShort: 'Година',
    program: 'Програм',
    project: 'Пројекат',
    positionChapter: 'Раздео',
    positionSubchapter: 'Глава',
    economicClassification: 'Конто',
    sourceOfFunding: 'Извор',
    function: 'Функција',
    amount: 'Износ',
    currentAmount: 'Текући износ',
    setAppropriationsSuccessful: 'Успешно сте ажурирали апропријације',
    setAppropriationsWarning: 'Ажурирање није извршено јер није било промена',
    showSelected: 'Прикажи изабране',
    showAll: 'Прикажи све'
  },
  reports: {
    projectsByPhase: 'По фазама',
    projectsByPhaseDescription: 'Распоред КП по ОП и по фазама',
    projectsByOrganization: 'По овлашћеним предлагачима',
    projectsByOrganizationDescription: 'Процењена вредност КП по ОП',
    importantProjects: 'Капитални пројекти',
    importantProjectsDescription: 'Капитални пројекти од посебног значаја',
    reportsTitle: 'Извештаји',
    reportsDescription: 'Преглед извештаја',
    projectListReportTitle: 'Списак Пројеката',
    projectListReportDescription: 'Списак пројеката по овлашћеном предлагачу',
    projectSummaryReportTitle: 'Сумарни Преглед',
    projectSummaryReportDescription: 'Сумарни преглед КП према предлагачу',
    projectsRealizedReportTitle: 'Реализовани',
    projectsRealizedReportDescription: 'Реализовани пројекти',
    projectsInRealizationReportTitle: 'У реализацији',
    projectsInRealizationReportDescription: 'Пројекти у реализацији',
    projectsAllReportTitle: 'Сви',
    projectsAllReportDescription: 'Сви пројекти у систему',
    projectsMeiExport: 'Експорт листе у XLS',
    projectsExport: 'Експорт листе у XLS',
    projectsExportAtDay: 'Експорт листе у XLS на дан',
    projectsBoardAccepted: 'Прихваћени од стране комисије',
    rojectsBoardAcceptedDescription: 'Сви пројекти прихваћени од стране комисије'
  },
  projects: {
    tabs: {
      details: 'Детаљи',
      stages: 'Етапе',
      documents: 'Документа',
      options: 'Опције',
      forms: 'Обрасци',
      activities: 'Активности',
      organizations: 'Посматрачи',
      appropriations: 'Апропријације',
      history: 'Историја',
      settings: 'Подешавања',
      merging: 'Повезивање',
      lists: 'Листе'
    },
    listTypes: {
      1: 'Предлог за рационализацију',
      2: 'Рационализација',
      3: 'Идеја',
      4: 'Предлог КП',
      5: 'Спремност',
      6: 'Корекција'
    },
    notOnList: '(Пројекат није на листи)',
    noMfinComment: '(Није унет коментар МФ)',
    noMfinCommentDialog: 'Није унет коментар МФ',
    commissionDecisionModalText: 'Да ли је комисија одлучила да пројекат иде у следећу фазу? Ако да, иде се у следећу фазу. Ако не, пројекат иде у стање мировања.',
    downloadList: 'Преузми листу',
    downloadConfirmedList: 'Преузми усвојену листу',
    changedValue: 'Измењена вредност',
    export: 'Извоз пројекта',
    exportId: 'Лична карта пројекта',
    sendListPrompt: 'Да ли сте сигурни да желите да креирате листу?',
    createRationalizationList: 'Креирај листу пројеката за рационализацију',
    createProposalRationalizationList: 'Креирај листу пројеката за рационализацију',
    createProjectIdentificationList: 'Креирај предлог листе пројеката у припреми',
    createIdeaList: 'Креирај предлог јединствене листе пројектних идеја',
    createPreparednessList: 'Креирај предлог листе припремљених пројеката',
    createCorrectionList: 'Креирај листу пројеката за корекцију',
    createImportantList: 'Креирај листу пројеката од посебног значаја',
    sendListSuccessful: 'Успешно сте послали листу комисији',
    historyLists: 'Историјске листе',
    listName: 'Назив',
    menuDescription: 'Креирање новог пројекта, преглед и управљање постојећим пројектима',
    projectsArchiveTitle: 'Архива',
    projectsArchiveDescription: 'Архивирани пројекти',
    listMenuDescription: 'Креирање листе пројеката, преглед и управљање листама пројеката',
    registryMenuDescription: 'Преглед шифарника',
    projectManagementDescription: 'Преглед и управљање постојећим капиталним пројектима',
    projectCreateDescription: 'Након успешног креирања пројекта бићете пребачени на страну за преглед детаља новог пројекта',
    project: 'Пројекат',
    viewProjects: 'Преглед пројеката',
    viewProjectsArchived: 'Преглед архивираних пројеката',
    createProject: 'Креирање пројекта',
    name: 'Назив пројекта',
    number: 'Идентификатор',
    code: 'Радни назив',
    important: 'Пројекат од посебног значаја',
    projectStage: 'Етапа',
    codeInfo: 'Кратак радни назив пројекта',
    codeInfoDesc: 'Мора садржати између 3 и 20 карактера. Дозвољена су само енглеска латинична слова, бројеви и карактери _  и -',
    codeUpdateInfoDesc: 'Измена радног назива мења browser линк (URL) ка ПИМИС пројекту.',
    codeUpdateInfoDesc2: 'Након измене, постојећи линкови престају да функционишу, уколико су коришћени било ван или у оквиру ПИМИС система',
    codeUpdateWarning: 'Упозорење',
    nameInfoDesc: 'Вредност назива која се дефинише у опцијама има предност у односу на вредност дефинисану у обрасцу. Постављањем празне вредности у опцијама узима се вредност из обрасца',
    importantInfoDesc: 'Вредност пројекта од посебног значаја која се дефинише у опцијама има предност у односу на вредност дефинисану у обрасцу. Постављањем празне вредности у опцијама узима се вредност из обрасца',
    updateCode: 'Промени радни назив',
    draftName: 'Назив нацрта пројекта',
    description: 'Опис пројекта',
    draftDescription: 'Опис нацрта пројекта',
    organization: 'Организација',
    officalProposerOrganization: 'Овлашћени предлагач',
    proposerOrganization: 'Предлагач пројекта',
    notDefinedNameAndDesc: 'Назив и опис пројекта још увек нису унети у ПИФ образац',
    notDefinedData: 'Није дефинисано',
    type: 'Тип пројекта',
    sector: 'Сектор',
    status: 'Статус пројекта',
    phase: 'Фаза',
    phasePreparation: 'Припрема',
    phaseRealization: 'Реализација',
    phaseFinished: 'Завршен',
    stage: 'Етапа',
    phаseStatus: 'Статус етапе',
    lastReporting: 'Последњи квартал',
    estimateTotal: 'Процењена вредност',
    totalValue: 'Укупна вредност',
    count: 'Број пројеката',
    createdUser: 'Креирао',
    createdDate: 'Датум креирања',
    changedDate: 'Датум активности',
    changedUser: 'Спровео',
    startedDate: 'Почетак',
    endedDate: 'Крај',
    lastChangedDate: 'Последња активност',
    submitFormPrompt: 'Да ли сте сигурни да желите да закључате образац са упозорењима?',
    deleteOrganizationPrompt: 'Да ли сте сигурни да желите да онемогућите приступ организацији?',
    deleteOrganizationPermission: 'Немате овлашћења за мењање приступа организацијама',
    createProjectTitle: 'Потврда пројекта',
    createProjectPrompt: 'Да ли сте сигурни да желите да креирате пројекат?',
    createProjectSuccessful: 'Успешно сте креирали пројекат',
    updateProjectSuccessful: 'Успешно сте ажурирали пројекат',
    submitProjectFormInputSuccessful: 'Успешно сте ажурирали пројектни образац',
    submitProjectFormInputSuccessfulWithErrorsAndWarnings: 'Успешно сте ажурирали пројектни образац. Постоје одређене грешке и упозорења које можете видети у дну екрана у одељку - Валидације',
    submitProjectFormInputSuccessfulWithErrors: 'Успешно сте ажурирали пројектни образац. Постоје одређене грешке које можете видети у дну екрана у одељку - Валидације',
    submitProjectFormInputSuccessfulWithWarnings: 'Успешно сте ажурирали пројектни образац. Постоје одређена упозорења које можете видети у дну екрана у одељку - Валидације',
    submitProjectFormInputWarning: 'На обрасцу није било промена па ажурирање није извршено',
    submitProjectFormInputError: 'Закључавање обрасца није могуће јер постоје грешке. Детаље можете видети у дну екрана у одељку - Валидације',
    markProjectFormInputSuccessful: 'Успешно сте оценили пројектни образац',
    projectInformation: 'Основне информације о пројекту',
    projectNoInformation: 'Нема информација',
    projectDraftInformation: 'Основне информације о нацрту пројекту',
    projectOfficialProposer: 'Овлашћени предлагач капиталног пројекта',
    projectProposer: 'Предлагач идеје капиталног пројекта',
    pifForm15: 'ПИФ Образац 1.5',
    pifForm150: 'Упутство за попуњавање',
    pifForm151: 'Секција 1',
    pifForm152: 'Секција 2',
    pifForm153: 'Секција 3',
    pifForm154: 'Секција 4',
    pifForm155: 'Секција 5',
    pifFormTitle150: 'ПИФ 1.5 упутство',
    pifFormTitle151: 'ПИФ 1.5.1',
    pifFormTitle152: 'ПИФ 1.5.2',
    pifFormTitle153: 'ПИФ 1.5.3',
    pifFormTitle154: 'ПИФ 1.5.4',
    pifFormTitle155: 'ПИФ 1.5.5',
    phaseDetails: 'Детаљи одабране фазе',
    lockForm: 'Закључавање обрасца',
    fileUploadSection: 'Документи пројекта',
    formLocked: 'Закључан',
    formValid: 'Верификован',
    organziationAdd: 'Додај организацију',
    fileAdd: 'Додај',
    fileUpload: 'Сачувај',
    cancelFileUpload: 'Откажи',
    errorPanelHeader: 'Списак грешака',
    optionsDescription: 'Опције пројекта омогућавају експлицитну доделу приступа пројекту другим организацијама као и подешавање детаља пројекта',
    sendToListDescription: 'У оквиру пројекта од посебног значаја, имате могућност да изаберете на којим свим списковима желите приказати овај пројекат.',
    mergingProjectDescription: 'Спајање пројекта са постојећим пројектом.',
    foreignFunds: 'Финансиран из ЕУ',
    document: {
      name: 'Назив',
      revision: 'Ревизија',
      description: 'Опис',
      comment: 'Коментар',
      add: 'Нови документ',
      revisionAdd: 'Нова ревизија',
      descriptionText: 'Одаберите датотеке за укључивање у пројекат. Максимална величина документа је ',
      warning: 'У случају великог броја датотека или лошије интернет конекције, слање датотека може потрајати',
      descriptionEmpty: 'Опис је обавезан податак',
      sizeLimitReached: 'Ограничење за величину фајла је ',
      countLimitReached: 'Ограничење за број фајлова је ',
      extensionInvalid: 'Тип документа није дозвољен',
      linkCopied: 'Копиран линк - ',
      createdDate: 'Датум креирања',
      phase: 'Етапа',
      hash: 'Хеш',
      size: 'Величина',
      extension: 'Екстензија',
      revisions: 'Ревизије документа',
      revisionsCount: 'Број ревизија',
      downloads: 'Преузимања',
      user: 'Корисник',
      firstDownloadDate: 'Датум првог преузимања',
      lastDownloadDate: 'Датум последњег преузимања',
      actions: 'Акције',
      download: 'Преузми',
      delete: 'Обриши',
      linkCopy: 'Копирај линк',
      linkOptions: 'Опције линка',
      back: 'Назад',
      deletePrompt: 'Да ли сте сигурни да желите да обришете документ?',
      editPrompt: 'Измена атрибута документа',
      exportAll: 'Преузми све документе',
      addDocumentTitle: 'Додавање новог документа',
      addRevisionTitle: 'Додавање нове ревизије',
      secured: 'Заштићен',
      securedDescription: 'Преузимање документа захтева ауторизацију и аутентикацију ПИМИС сервиса',
      public: 'Јавни',
      publicDescription: 'Документ може преузети било ко путем интернета, уколико поседује овај линк',
      anonymous: 'Анонимни корисник',
      error: 'Грешка',
      type: 'Тип документа',
      documentType: 'Тип документа',
      types: {
        0: 'Друго',
        1: 'Идеја - финансирање',
        2: 'Идеја - стратегија',
        3: 'ПредлогКП - ИЗДАКОН',
        4: 'ПредлогКП - животна средина',
        5: 'Спремност - ИЗДАКОН',
        6: 'Спремност - студије',
        7: 'Спремност - извештај',
        8: 'КППЗ - одлука - Владе РС',
        9: 'ПредлогКП - Писмо о намерама',
        10: 'ПредлогКП - Размена електронске поште',
        11: 'ПредлогКП - Писмо о намерама спољашњег финансијера',
        12: 'ПредлогКП - Приказ извора процене укупних трошкова капиталног пројекта',
        13: 'Корекција - Образложење разлога одступања',
        14: 'Корекција - Доказ навода',
        15: 'Завршетак КП - Извештај',
        16: 'Рационализација - Извештај о гашењу',
        17: 'Рационализација - одлука о гашењу',
        18: 'Рационализација - Одлука о одлагању',
        19: 'Спремност - Оквирни план реализације'
      }
    },
    commentRequired: 'Коментар је обавезан податак',
    dateValid: 'Датум је обавезан податак',
    invokeActionPrompt: 'Да ли желите да потврдите изабрану акцију?',
    invokeRationalizationProposalActionPrompt: 'Да ли је пројекат за рационализацију?',
    invokeRationalizationActionPrompt: 'Изаберите одлуку комисије',
    invokeActionSuccessful: 'Успешно сте извршили акцију',
    invokeCorrectionActionPrompt: 'Потврдите слање пројекта на корекцију',
    jsonDataChange: 'Директна измена података',
    actions: 'Акције',
    forms: 'Обрасци',
    form: 'образац',
    formMinipif: 'пиф-мини',
    formPreImplementation: 'припрема',
    formPlan: 'план',
    comment: 'Коментар',
    timeToProjectImplementation: 'ВДР',
    inactivity: 'Неактивност',
    fundingAdequacyIndicator: 'ПАФ',
    showFinished: 'Прикажи завршене',
    addOrganization: 'Додај корисника',
    types: {
      1: 'Пројекат у реализацији',
      2: 'Пројекат у припреми',
      3: 'Нова реализација'
    },
    sectors: {
      1: 'Универзални',
      2: 'Саобраћај',
      3: 'Енергетика',
      4: 'Животна средина - управљање отпадом',
      5: 'Животна средина - управљање водама',
      6: 'Пословна конкурентност'
    },
    stages: {
      0: 'Идеја',
      1: 'Предлог КП',
      2: 'Спремност',
      3: 'КППЗ',
      4: 'План',
      5: 'Извештавање',
      7: 'Завршетак КП',
      8: 'Екс-пост',
      11: 'Корекција',
      12: 'Извештавање корекција',
      13: 'Рационализација',
      null: ''
    },
    statuses: {
      0: 'У току',
      1: 'Завршен'
    },
    phaseStatuses: {
      1: 'Унос',
      99: 'Враћен на допуну',
      2: 'Чека одобрење',
      3: 'Чека потврду пријема',
      4: 'Потврђен пријем',
      5: 'Предлог за рационализацију',
      6: 'Чека одлуку комисије',
      7: 'Корекција',
      8: 'Одложен',
      9: 'Угашен',
      10: 'Прихваћена рационализација',
      11: 'Отказан',
      12: 'Чека потврду квартала',
      13: 'Чека одобрење квартала',
      14: 'Чека да се дода на листу',
      15: 'Чека одобрење Предлог КП пројекта',
      16: 'Чека одобрење спремности',
      17: 'Пос-значаја',
      18: 'Мировање',
      19: 'Пошаљи на сагласност',
      20: 'Чека на сагласност',
      21: 'Пошаљи на потврду министра',
      22: 'Чека на потврду министра',
      23: 'Чека слање на МЕИ оцену',
      24: 'Чека на потврду МЕИ оцене',
      25: 'Послат захтев за измену образца',
      26: 'Послат на корекцију',
      27: 'Потврђена корекција',
      28: 'Чека да се дода на листу',
      29: 'Корекција - допуна',
      30: 'Рационализација - одлагање',
      31: 'Рационализација - гашење',
      32: 'Послат на рационализацију',
      33: 'Корекција допуна - чека одобрење допуне',
      34: 'Корекција допуна - чека потврду пријема'
    },
    projectStages: {
      1: 'Припрема',
      2: 'Реализација',
      3: 'Идеја',
      4: 'Предлог КП',
      5: 'Спремност'
    },
    activities: {
      '011': 'Идеја - Унос обрасца',
      '012': 'Идеја - Послат на одобрење',
      '021': 'Идеја - Одбијен са одобрења',
      '023': 'Идеја - Одобрен',
      '031': 'Идеја - Одбијен са потврђења',
      '034': 'Идеја - Потврђен',
      '0414': 'Идеја - Послат на листу',
      '0146': 'Идеја - Чека на одлуку комисије',
      '064': 'Идеја - Комисија је одобрила',
      '01919': 'Идеја - Шаљи на верификацију',
      '02019': 'Идеја - Одбијен са верификације',
      '01920': 'Идеја - Верификација',
      '0201': 'Идеја - Пошаљи на одобрење',
      '0221': 'Идеја - Одобрење',
      '0223': 'Идеја - Министар одобрио',
      '02122': 'Идеја - Слање министру на одобрење',
      '02223': 'Потбрћено од стране министра',
      '02324': 'Послато МЕИ на оцену',
      '0243': 'Потврђено за слање у МФИН',
      '041': 'Враћен образац Идеје на допуну',
      '0425': 'Идеја - Послат захтев за измену образца',
      '0251': 'Идеја - Враћен образац на измену',
      141: 'Враћен образац ПредлогКП на допуну',
      110: 'Предлог КП - Унос обрасца',
      111: 'Предлог КП - Унос обрасца',
      112: 'Предлог КП - Послат на одобрење',
      121: 'Предлог КП - Одбијен са одобрења',
      123: 'Предлог КП - Одобрен',
      131: 'Предлог КП - Одбијен са потврђења',
      134: 'Предлог КП - Потврђен',
      1415: 'Предлог КП - Послат на листу',
      1156: 'Предлог КП - Чека на одлуку комисије',
      1425: 'Предлог КП - Послат захтев за измену образца',
      1251: 'Предлог КП - Враћен образац на измену',
      164: 'Предлог КП - Комисија је одобрила',
      211: 'Спремност - Унос обрасца',
      212: 'Спремност - Послат на одобрење',
      221: 'Спремност - Одбијен са одобрења',
      223: 'Спремност - Одобрен',
      231: 'Спремност - Одбијен са потврђења',
      234: 'Спремност - Потврђен',
      2166: 'Спремност - Послат на листу',
      241: 'Враћен на допуну од стране МФИН',
      2416: 'Спремност - Чека на одлуку комисије',
      264: 'Спремност - Комисија је одобрила',
      2425: 'Спремност - Послат захтев за измену образца',
      2251: 'Спремност - Враћен образац на измену',
      364: 'КППЗ - Комисија је одобрила',
      311: 'КППЗ -Унос обрасца',
      312: 'КППЗ - Послат на одобрење',
      321: 'КППЗ - Одбијен са одобрења',
      323: 'КППЗ - Одобрен',
      331: 'КППЗ - Одбијен са потврђења',
      334: 'КППЗ - Потврђен',
      464: 'План - Комисија је одобрила',
      411: 'План - Унос обрасца',
      412: 'План - Послат на одобрење',
      421: 'План - Одбијен са одобрења',
      423: 'План - Одобрен',
      431: 'План - Одбијен са потврђења',
      434: 'План - Потврђен',
      564: 'Извештавање - Комисија је одобрила',
      511: 'Извештавање - Унос обрасца',
      512: 'Извештавање - Послат на одобрење',
      521: 'Извештавање - Одбијен са одобрења',
      523: 'Извештавање - Одобрен',
      531: 'Извештавање - Одбијен са потврђења',
      534: 'Извештавање - Потврђен',
      517: 'Извештавање - Корекција',
      561: 'Извештавање - Одбијен од комисије предлог за рационализацију',
      556: 'Извештавање - Послат на комисију предлог за рационализацију',
      515: 'Извештавање - Послат на предлог за рационализацију',
      51212: 'Извештавање - Одбијена потврда квартала',
      5112: 'Извештавање - Потврђен квартал',
      512131: 'Извештавање - Одобрен квартал',
      5131: 'Извештавање - Одбијен квартал',
      5134: 'Извештавање - Одобрен квартал',
      5126: 'Извештавање - Послат на корекцију',
      5326: 'Извештавање - Послат на корекцију',
      664: 'Рационализација - Комисија је одобрила',
      611: 'Рационализација - Унос обрасца',
      612: 'Рационализација - Послат на одобрење',
      621: 'Рационализација - Одбијен са одобрења',
      623: 'Рационализација - Одобрен',
      631: 'Рационализација - Одбијен са потврђења',
      634: 'Рационализација - Потврђен',
      646: 'Рационализација - Послат на комисију за рационализацију',
      667: 'Рационализација - Корекција',
      668: 'Рационализација - Одлагање',
      669: 'Рационализација - Угашен',
      711: 'Закључак - Унос обрасца',
      712: 'Закључак - Послат на одобрење',
      721: 'Закључак - Одбијен са одобрења',
      723: 'Закључак - Одобрен',
      731: 'Закључак - Одбијен са потврђења',
      734: 'Закључак - Потврђен',
      811: 'Екс-пост - Унос обрасца',
      812: 'Екс-пост - Послат на одобрење',
      821: 'Екс-пост - Одбијен са одобрења',
      823: 'Екс-пост - Одобрен',
      831: 'Екс-пост - Одбијен са потврђења',
      834: 'Екс-пост - Потврђен',
      '0112': 'Послат на потврду квартала',
      '0123': 'Послат на одобрење',
      '01211': 'Потврђен квартал',
      '01212': 'Одбијен квартал',
      '0121': 'Одбијен са потврде',
      '0111': 'Отказана припрема',
      '0211': 'Отказана припрема',
      '0311': 'Отказана припрема',
      3112: 'Послат на потврду квартала',
      31212: 'Одбијен квартал',
      312131: 'Послат на одобрење квартала',
      312132: 'Одбијен квартал',
      3131: 'Одбијен квартал',
      3134: 'Одобрен квартал',
      3135: 'Предложен за рационализацију',
      3125: 'Предложен за рационализацију',
      315: 'Предложен за рационализацију',
      325: 'Предложен за рационализацију',
      335: 'Предложен за рационализацију',
      345: 'Предложен за рационализацију',
      356: 'Послат комисији на одлуку',
      361: 'Одбијен предлог рационализације',
      362: 'Одбијен предлог рационализације',
      363: 'Одбијен предлог рационализације',
      3612: 'Одбијен предлог рационализације',
      3613: 'Одбијен предлог рационализације',
      366: 'Прихваћена рационализација',
      3610: 'Прихваћена рационализација',
      317: 'Корекција',
      327: 'Корекција',
      337: 'Корекција',
      347: 'Корекција',
      3127: 'Корекција',
      3137: 'Корекција',
      446: 'Послат комисији на одлуку',
      467: 'Корекција',
      468: 'Одложен',
      469: 'Угашен',
      1111: 'Корекција - Унос обрасца',
      1112: 'Корекција - Послат на одобрење',
      1123: 'Корекција - Одобрен',
      1134: 'Корекција - Потврђен',
      1166: 'Корекција - пројекат уврштен у листу за комисију',
      113329: 'Корекција допуна - враћен на дораду',
      112933: 'Корекција допуна - послат на одобрење',
      11428: 'Прихваћена корекција',
      11344: 'Прихваћена допуна корекције',
      113334: 'Одобрена допуна корекције',
      113429: 'Одбијена допуна корекције и враћена на дораду',
      11629: 'Комисија послала на допуну',
      11286: 'Корекција послата на листу',
      1121: 'Корекција - враћен на допуну',
      1131: 'Корекција - враћен на допуну од стране МФИН',
      11126: 'Извештавање - Послат на корекцију',
      1164: 'Корекција - Комисија је одобрила',
      1210: 'Корекција извештавање - Отварање обрасца',
      1211: 'Корекција извештавање - Унос обрасца',
      1212: 'Корекција извештавање - Послат на одобрење',
      1221: 'Корекција извештавање - Одбијен са одобрења',
      1223: 'Корекција извештавање - Одобрен',
      1231: 'Корекција извештавање - Одбијен са потврђења',
      1234: 'Корекција извештавање - Потврђен',
      1217: 'Корекција извештавање - Корекција',
      1261: 'Корекција извештавање - Одбијен од комисије предлог за рационализацију',
      1256: 'Корекција извештавање - Послат на комисију предлог за рационализацију',
      1215: 'Корекција извештавање - Послат на предлог за рационализацију',
      121212: 'Корекција извештавање - Одбијена потврда квартала',
      12112: 'Корекција извештавање - Потврђен квартал',
      1212131: 'Корекција извештавање - Одобрен квартал',
      12131: 'Корекција извештавање - Одбијен квартал',
      12134: 'Корекција извештавање - Одобрен квартал',
      12126: 'Корекција извештавање - Послат на корекцију',
      12326: 'Корекција извештавање - Послат на корекцију'
    },
    importantFilter: {
      0: 'Да',
      1: 'Не'
    },
    EUFilter: {
      0: 'Да',
      1: 'Не'
    },
    activity: 'Активност',
    operation: 'Операција',
    requiredItem: 'Редни број ставке на форми: ',
    required: 'Неопходно је унети вредност за наведену ставку',
    formStatuses: {
      1: 'На уносу',
      2: 'Закључан',
      3: 'Оцењен',
      4: 'Одобрен'
    },
    revisions: 'Ревизије',
    emptyProjectName: 'Добродошли на нови ПИМИС пројекат',
    emptyProjectDescription: `Сваки пројекат пролази кроз више различитих етапа. **Етапа пројекта** је један део комплетног пословног процеса у току трајања пројекта. Свака етапа садржи различите типове и број **образаца** у оквиру којих се уносе потребни подаци релевантни за ту фазу.

Корисници система спроводе следеће активности након уноса података у обрасце:

1. **Закључавање**
Спречава накнадне измене обрасца и омогућава активност слања на потврду.
*Спроводи: Овлашћени предлагач - Локални корисник.*
2. **Слање на одобрење**
Корисници који уносе податке су завршили процес уноса и шаљу образац на одобрење.
*Спроводи: Овлашћени предлагач - Локални корисник*
3. **Oдобрење**
Власник пројекта потврђује да је унос коректан, или враћа образац на корекцију.
*Спроводи: Овлашћени предлагач - Локални администратор*
4. **Потврда**
МФИН администратор потврђује пријем обрасца ако сматра да је у складу са уредбом, или враћа образац на корекцију.
*Спроводи: Министарство Финансија - Администрација*

Наведене активности се спроводе приликом попуњавања било ког обрасца било које етапе. Етапа може имати и додатне опције и активности. Сви корисници који могу приступити пројекту имају трајан и детаљан увид у листу свих активности које су на њему спроведене. На овај начин омогућено је праћење дешавања на пројекту између било која два временска тренутка.

За све додатне информације користите дугме **контекстуалне помоћи** <i aria-hidden="true" class="v-icon notranslate mdi mdi-help-circle theme--light primary--text"></i> у горњем десном углу сваке странице. Помоћ садржи детаљне информације о свим етапама и обрасцима.`
  },
  validation: {
    warning: 'Упозорења',
    error: 'Грешке',
    success: 'Без грешака и упозорења',
    nameRequired: 'Неопходно је унети име',
    usernameRequired: 'Неопходно је унети корисничко име',
    nameShortRequired: 'Неопходно је унети скраћени назив',
    emailRequired: 'Неопходно је унети електронску пошту',
    claimRequired: 'Неопходно је означити бар једну улогу или овлашћење',
    usernameTooLong: 'Скраћени назив може садржати највише 10 знака',
    nameShortTooLong: 'Корисничко име може садржати највише 32 знака',
    filterUrlRequired: 'Неопходно је унети филтер URL',
    oldPasswordNecessary: 'Неопходно је унети стару лозинку',
    newPasswordNecessary: 'Неопходно је унети стару лозинку',
    repeatedPasswordNecessary: 'Неопходно је унети стару лозинку',
    repeatedPasswordNotMatch: 'Нова и поновљена лозинка морају да се подударају',
    repeatMustMatch: 'Лозинке се не поклапају',
    oldPasswordRequired: 'Морате унети стару лозинку',
    password: {
      0: 'Број карактера лозинке није исправан',
      1: 'Лозинка мора садржати бројеве',
      2: 'Лозинка мора садржати велика слова',
      3: 'Лозинка мора садржати симболе'
    },
    roleNameTooLong: 'Назив корисничке улоге може садржати највише 32 знака',
    roleDescriptionTooLong: 'Опис корисничке улоге може садржати највише 128 знака'
  },
  userStatus: {
    1: 'Активан',
    2: 'Неактиван',
    3: 'Опозван',
    4: 'Опозван приступ'
  },
  roleType: {
    1: 'Системска',
    2: 'Администрација',
    3: 'Корисничка'
  },
  rowStatus: {
    active: 'Активан',
    inactive: 'Неактиван'
  },
  userGroupStatus: {
    1: 'Активна',
    2: 'Неактивна'
  },
  jsonEditor: {
    button_add: 'Додај',
    button_add_row_title: 'Додај {{0}}',
    button_cancel: 'Откажи',
    button_collapse: 'Скупи',
    button_copy: 'Копирај',
    button_copy_row_title: 'Копирај {{0}}',
    button_copy_row_title_short: 'Копирај',
    button_delete_all: 'Све',
    button_delete_all_title: 'Обриши све',
    button_delete_last: 'Последњи {{0}}',
    button_delete_last_title: 'Обриши последњи {{0}}',
    button_delete_node_warning: 'Да ли сте сигурни да желите да обришете?',
    button_delete_row_title: 'Обриши {{0}}',
    button_delete_row_title_short: 'Обриши',
    button_edit_json: 'Ажурирај JSON',
    button_expand: 'Прошири',
    button_move_down_title: 'Помери доле',
    button_move_up_title: 'Помери горе',
    button_object_properties: 'Својства објекта',
    button_properties: 'Својства',
    button_save: 'Сачувај',
    button_upload: 'Учитај',
    choices_placeholder_text: 'Почни да куцаш да би додао вредност',
    default_array_item_title: 'елемент',
    error_additionalItems: 'У овом низу нису дозвољене додатни елементи',
    error_additional_properties: ' ', // 'Нису дозвољена додатна својства, али је својство {{0}} подешено'
    error_anyOf: 'Вредност мора да се потврди у односу на најмање једну од наведених шема',
    error_const: 'Вредност мора бити константа',
    error_date: 'Датум мора бити у формату {{0}}',
    error_datetime_local: 'Датум мора бити у формату {{0}}',
    error_dependency: 'Мора имати својство {{0}}',
    error_disallow: 'Вредност не може бити тип {{0}}',
    error_disallow_union: 'Вредност не може бити једна од недозвољених типова',
    error_enum: 'Вредност мора бити једна од нвредности',
    error_hostname: 'Име хоста има погрешан формат',
    error_invalid_epoch: 'Датум мора бити већи од 1. јануара 1970.',
    error_ipv4: 'Вредност мора бити важећа IPv4 адреса у облику 4 броја између 0 и 255, раздвојена тачкама',
    error_ipv6: 'Вредност мора бити важећа IPv6 адреса',
    error_maxItems: 'Вредност мора имати највише {{0}} елемената',
    error_maxLength: 'Вредност мора имати највише {{0}} карактера',
    error_maxProperties: 'Објекат мора имати највише {{0}} својстава',
    error_maximum_excl: 'Вредност мора бити мања од {{0}}',
    error_maximum_incl: 'Вредност мора бити највише {{0}}',
    error_minItems: 'Вредност мора имати најмање {{0}} ставки',
    error_minLength: 'Вредност мора имати најмање {{0}} карактера',
    error_minProperties: 'Објекат мора да има најмање {{0}} својства',
    error_minimum_excl: 'Вредност мора бити већа од {{0}}',
    error_minimum_incl: 'Вредност мора бити најмање {{0}}',
    error_multipleOf: 'Вредност мора бити вишеструка од {{0}}',
    error_not: 'Вредност не сме да се потврди у односу на дату шему',
    error_notempty: 'Вредност је обавезна',
    error_notset: 'Својство мора бити дефинисано',
    error_oneOf: 'Вредност мора да се потврди у односу на тачно једну од датих шема. Тренутно се проверава у односу на {{0}} шема.',
    error_pattern: 'Вредност мора одговарати шаблону {{0}}',
    error_property_names_const_mismatch: 'Име својства {{0}} се не подудара са вредношћу константе',
    error_property_names_enum: 'Име својства {{0}} не може се подударати са неважећим енумом',
    error_property_names_enum_mismatch: 'Име својства {{0}} не одговара ниједној вредности енума',
    error_property_names_exceeds_maxlength: 'Назив својства {{0}} премашује максималну дужину',
    error_property_names_false: 'Име својства {{0}} добија грешку када је име својства false',
    error_property_names_maxlength: 'Име својства {{0}} не може се подударати са неважећом максималном дужином',
    error_property_names_pattern: 'Назив својства {{0}} не може се подударати са неважећим шаблоном',
    error_property_names_pattern_mismatch: 'Име својства {{0}} се не подудара са шаблоном',
    error_property_names_unsupported: 'Неподржано име својства {{0}}',
    error_required: 'Објекту недостаје обавезно својство {{0}}',
    error_time: 'Време мора бити у формату {{0}}',
    error_type: 'Вредност мора бити типа {{0}}',
    error_type_union: 'Вредност мора бити једно од наведених типова',
    error_uniqueItems: 'Низ мора имати јединствене елементе',
    flatpickr_clear_button: 'Oчисти',
    flatpickr_toggle_button: 'Укључи/Искључи'
  },
  apiStatusCodes: {
    0: 'Није могуће успоставити конекцију, покушајте поново након пар минута',
    400: 'Обрада захтева није успела',
    401: 'Грешка приликом ауторизације корисника',
    403: 'Немате одговарајуће корисничке привилегије',
    404: 'Није пронађена захтевана страна',
    422: 'Валидационе грешке',
    429: 'Лимит на број упућених захтева је достигнут',
    500: 'Грешка приликом употребе сервиса, молимо контактирајте техничку подршку',
    PROJECT_NAME: 'Назив пројекта није валидан',
    ERR_PROCESS_GET_REQUEST: 'Грешка приликом слања захтева на позадински сервис',
    ERR_PROCESS_POST_REQUEST: 'Грешка приликом слања захтева на позадински сервис',
    row: 'Ред',
    Success: 'Success',
    ValidationError: 'Валидациона грешка',
    Forbidden: 'Немате права на ову акцију',
    NotFound: 'Путања није пронађена',
    // //notice
    // validations
    NoticeStatus: 'Није могуће ажурирати обавештење у датом статусу. Обавештење мора бити у будућности',
    NoticeActivity: 'Није могуће ажурирати неактивно обавештење',
    // fluent validation
    InvalidNoticeTextValidation: 'Текст нотификације није валидан',
    InvalidNoticeStartsDateLessThenNowValidation: 'Датум почетка не може бити у прошлости',
    InvalidNoticeTimeFromValidation: 'Време од је обавезан податак',
    InvalidNoticeEndsDateLessThenStartsDateValidation: 'Датум краја мора бити већи од датума почетка',
    InvalidNoticeEndsDateValidation: 'Датум краја је обавезан податак',
    InvalidNoticeTimeToValidation: 'Време до је обавезан податак',
    InvalidNoticeTimeToLessThenTimeFromValidation: 'Време до мора бити веће од времена од',
    InvalidNoticeTimeToLessThenNowValidation: 'Време до мора бити веће од тренутног времена',
    InvalidNoticePriorityValidation: 'Приоритет није валидан',
    // unknown errors
    UnCreateNotice: 'Непозната грешка приликом креирања обавештења',
    UnRetrieveNotices: 'Непозната грешка приликом добијања обавештења',
    UnRetrieveNotice: 'Непозната грешка приликом добијања обавештења',
    UnUpdateNotice: 'Непозната грешка приликом ажурирања обавештења',
    UnDeleteNotice: 'Непозната грешка приликом брисања обавештења',
    UnCancelNotice: 'Непозната грешка приликом отказивања обавештења',
    // db errors
    DbCreateNotice: 'Грешка приликом креирања обавештења',
    DbRetrieveNotices: 'Грешка приликом добијања обавештења',
    DbRetrieveNotice: 'Грешка приликом добијања обавештења',
    DbUpdateNotice: 'Грешка приликом ажурирања обавештења',
    DbDeleteNotice: 'Грешка приликом брисања обавештења',
    DbCancelNotice: 'Грешка приликом отказивања обавештења',
    // //mail
    // unknown errors
    UnSendMailMessage: 'Непозната грешка приликом слања емаила',
    // db errors
    DbCreateMailMessage: 'Грешка приликом креирања емаила',
    // //project
    UncompletedPhaseForms: 'Није могуће прећи на следећу фазу док постоје обрасци који нису обрађени',
    InvalidProjectFormSubmitor: 'Корисник нема овлашћења за ажурирање обрасца на пројекту',
    InvalidProjectFormEvaluator: 'Корисник нема овлашћења за оцењивање обрасца на пројекту',
    InvalidProjectAction: 'Акција није валидна',
    InvalidUserPermission: 'Корисник нема овлашћења за изабрану акцију',
    DuplicateProjectOrganization: 'Дупла организација',
    InvalidProjectFormPhase: 'Образац није могуће мењати у тренутној фази пројекта',
    InvalidProjectFormAction: 'Акција није могућа у тренутном статусу обрасца',
    InvalidProjectListProjects: 'Не постоји ни један валидан пројекат који испуњава услове листе',
    InvalidProjectFormValues: 'Вредности образаца нису валидне',
    DuplicateProjectAppropriation: 'Дупла апропријација',
    InvalidProjectAppropriation: 'Апропријација није валидна',
    ForbiddenProjectChange: 'Пројекат је у фази и статусу где није дозвољена промена',
    ReachedProjectDocumentRevisionsLimit: 'Није могуће додати нову ревизију документа. Достигнут је лимит по броју ревизија за документ',
    ReachedProjectDocumentsLimit: 'Није могуће додати нови документ. Достигнут је лимит по броју докумената за пројекат',
    AlreadyExistsProjectDocument: 'Документ са задатим именом већ постоји',
    UsedDocumentInForms: 'Није могуће обрисати документ. Документ се користи у обрасцима',
    InvalidApprovedFormsCount: 'Акција није валидна услед броја одобрених форми',
    InvalidProjectUpdateUser: 'Корисник нема привилегије да ажурира пројекат јер пројекат не припада његовој организацији',
    InvalidProjectUpdatePhase: 'Пројекат може бити ажуриран само у првој фази пројеката',
    InvalidProjectUpdatePhaseStatus: 'Пројекат може бити ажуриран само док није одобрена прва етапа пројекта',
    NotExistsProjectListDocument: 'Документ није пронађен',
    NotAllowedCreateProject: 'Креирање пројекта није дозвољено за организацију којој корисник припада',
    RetrieveSecuredProjectDocumentAnonymously: 'Није могуће преузети заштићен документ незаштићеним каналом',
    // Fluent validations
    FluentSectorEmpty: 'Резултати пројекта имају утицај на достизањe циљева или испуњавањe обавеза из сектора је обавезан податак',
    FluentEmptyProjectImportance: 'Пројекат од посебног значаја није дефинисан',
    FluentEmptyStrategicEvaluation: 'Оцена стратешке релевантности није дефинисана',
    FluentEmptyAppliedPlaningAndConstructionLow: 'Примењује се закон о планирању и изградњи није дефинисан',
    FluentEmptyPlanningDocumentation: 'Планска документација није дефинисана',
    FluentEmptySolvedPropertyLegalQuestions: 'Решена имовинскоправна питања нису дефинисана',
    FluentEmptyGeneralProjectResult: 'ПСО + ГНП/ПСИ није дефинисан',
    FluentEmptyConceptualProject: 'Идејно решење није дефинисано',
    FluentEmptyEnvironmentalImpactStudy: 'Студија утицаја на животну средину није дефинисана',
    FluentEmptyConceptualProjectResult: 'СО + ИДП/СИ није дефинисан',
    FluentEmptyProjectForBuildingPermit: 'Пројекат за грађевинску дозволу није дефинисан',
    FluentEmptyProjectForExecution: 'Пројекат за извођење није дефинисан',
    FluentEmptyTechnicalSpecification: 'Техничка спецификација и предуслови за спровођење јавне набавке',
    FluentInvalidProjectCode: 'Радни назив пројекта није валидан. Дозвољена су само слова енглеске латинице, бројеви и карактери _  и -',
    FluentEmptyProjectCode: 'Радни назив пројекта није дефинисан',
    FluentInvalidProjectCodeLength: 'Дужина радног назива пројекта није валидан. Мора бити већа од 3 и мања од 20',
    FluentInvalidProjectNameLength: 'Дужина назива пројекта није валидна. Мора бити мања од 512',
    FluentInvalidProjectType: 'Тип пројекта није валидан',
    FluentInvalidProjectSector: 'Сектор није валидан',
    FluentInvalidFormCode: 'Идентификатор обрасца није валидан',
    FluentInvalidFormAction: 'Акција обрасца није валидна',
    FluentEmptyFormValues: 'Вредности обрасца нису дефинисане',
    FluentInvalidPhaseAction: 'Акција фазе није валидна',
    FluentInvalidPhaseForm: 'Идентификатор обрасца није валидан',
    FluentInvalidFormRevision: 'Ревизија није валидна',
    FluentInvalidFormExportFormat: 'Формат извоза није валидан',
    FluentEmptyProjectFileTitle: 'Назив документа није дефинисан',
    FluentInvalidProjectFileTitleLength: 'Дужина назива документа није валидна',
    FluentEmptyProjectFileExtension: 'Екстензија документа није валидна',
    FluentInvalidProjectFileExtension: 'Екстензија документа није дефинисана',
    FluentInvalidProjectFileDescription: 'Дужина описа документа није валидна',
    FluentInvalidProjectFileComment: 'Дужина коментара документа није валидна',
    FluentInvalidProjectFileSize: 'Величина документа није валидна',
    FluentEmptyProjectFile: 'Документ није изабран',
    FluentInvalidProjectFileRevisionId: 'Ревизија није валидна',
    FluentInvalidProjectFileDocumentId: 'Идентификатор документа није валидан',
    FluentEmptyActivityName: 'Назив активности је обавезан податак',
    FluentEmptyActivityEstimate: 'Износ активности је обавезан податак',
    FluentInvalidActivityEstimateSum: 'Збир износа активности не одговара процењеној вредности пројекта',
    FluentInvalidPlanPercentSum: 'Збир процената активности мора бити једнак 100 или 0',
    FluentInvalidPlanAmountSum: 'Збир износа по кварталима мора бити једнак укупном износу активности',
    FluentDuplicateActivityName: 'Постоји дупла активност',
    FluentEmptyPlans: 'План је обавезан податак',
    FluentDuplicatePlanYear: 'Постоји дупла година на активностима',
    FluentEmptyProjectValueRSD: 'РСД валута је обавезна за процењену вредност пројекта',
    FluentInvalidProjectValueRSDFormat: 'Формат износа није валидан',
    FluentEmptyProjectValue: 'Процењена вредност пројекта је обавезан податак',
    FluentEmptyImplementationDates: 'Почетак и крај реализације су обавезни подаци',
    FluentInvalidImplementationDates: 'Крај реализације не може бити пре почетка',
    FluentInvalidImplementationDatesLength: 'Дужина реализације мора бити дужа од годину дана',
    FluentEmptyImplementationStartDate: 'Почетак реализације је обавезан податак',
    FluentInvalidImplementationStartDateFormat: 'Почетак реализације није валидан',
    FluentEmptyImplementationEndDate: 'Крај реализације је обавезан податак',
    FluentInvalidImplementationEndDateFormat: 'Крај реализације није валидан',
    FluentEmptyForeignAmounts: 'Процењена вредност у страним валутама није дефинисана',
    FluentEmptyForeignAmountAmount: 'Износ у страној валути код процењених вредности у страним валутама је обавезан податак',
    FluentInvalidForeignAmountAmount: 'Износ у страној валути код процењених вредности у страним валутама није валидан',
    FluentEmptyForeignAmountCurrency: 'Валута код процењених вредности у страним валутама је обавезан податак',
    FluentInvalidForeignAmountCurrency: 'Валута код процењених вредности у страним валутама није пронађена у регистру',
    FluentEmptyForeignAmountsEuroCurrency: 'Валута ЕУР код процењених вредности мора бити дефинисана',
    FluentInvalidForeignAmountsEuroAmount: 'Износ у ЕУР валути код процењених вредности мора бити већи од 5 000 000',
    FluentEmptyFinanceSources: 'Извор финансирања није дефинисан',
    FluentEmptyPreparationPlan: 'Процењена средства за припрему пројекта нису дефинисана',
    FluentEmptyImplementationPlan: 'Процењена средства за реализацију пројекта нису дефинисана',
    FluentEmptyPreparationPlanAmount: 'Недостаје износ у процењеним средствима за припрему пројекта',
    FluentInvalidPreparationPlanAmount: 'Несправан формат броја у процењеним средствима за припрему пројекта',
    FluentEmptyImplementationPlanAmount: 'Недостаје износ у процењеним средствима за реализацију пројекта',
    FluentInvalidImplementationPlanAmount: 'Несправан формат броја у процењеним средствима за реализацију пројекта',
    FluentDifferenceImportantEstimateSources: 'Планирана средства и извори финансирања у РСД нису једнаки',
    FluentEmptyFinanceSourceSource: 'Извор код извора финансирања је обавезан податак',
    FluentEmptyFinanceSourceName: 'Назив код извора финансирања је обавезан податак',
    FluentEmptyFinanceSourceLocalAmount: 'Износ у РСД код извора финансирања је обавезан податак',
    FluentInvalidFinanceSourceLocalAmount: 'Износ у РСД код извора финансирања није валидан',
    FluentEmptyFinanceSourceCurrency: 'Валута код извора финансирања је обавезан податак',
    FluentInvalidFinanceSourceCurrency: 'Валута код извора финансирања није пронађена у регистру',
    FluentEmptyFinanceSourceAmount: 'Износ у страној валути код извора финансирања је обавезан податак',
    FluentFinanceSourceSumInvalid: 'Збир износа у РСД валути код извора финансирања не одговара процењеној вредности пројекта',
    FluentInvalidFinanceSourceAmount: 'Износ у страној валути код извора финансирања није валидан',
    FluentEmptyPlanValues: 'Година у плану нема дефинисан ни један квартал за активност',
    FluentEmptyPlanValue: 'Квартал у плану нема дефинисан износ',
    FluentInvalidStartDate: 'Почетак реализације мора бити раније од датума првог квартала у активностима',
    FluentInvalidEndDate: 'Крај реализације мора бити касније од датума последњег квартала у активностима',
    FluentInvalidCorrEndDate: 'Ревидирани датум завршетка као резултат новог плана мора бити касније од датума последњег квартала у активностима',
    FluentInvalidStartDateQuarter: 'Почетак реализације није усклађен са првим кварталом у активностима',
    FluentInvalidStartDateCorrQuarter: 'Дан почетка новог плана реализације пројекта није усклађен са првим кварталом у активностима',
    FluentInvalidEndDateQuarter: 'Крај реализације није усклађен са последњим кварталом у активностима',
    FluentInvalidEndDateCorrQuarter: 'Ревидирани датум завршетка као резултат новог плана није усклађен са последњим кварталом у активностима',
    FluentEmptyActivity: 'Активност је обавезан податак',
    FluentActivityRealPlannedDiffEmpty: 'Када постоји разлика између остварених и планираних расхода морају се навести разлози за одступање, односно предузете мере.',
    FluentActivityPhysicalReasonEmpty: 'Када активност није у потпуности реализована у односу на План реализације морају се навести разлози за одступање, односно предузете мере.',
    FluentEmptyActivities: 'Активности нису дефинисане',
    FluentEmptyActivityRealExpense: 'Остварени расходи је обавезан податак',
    FluentInvalidActivityRealExpense: 'Остварени расходи морају бити већи од 0',
    FluentEmptyActivityPhysicalTargetNote: 'Разлог из којих међуциљ није остварен мора бити дефинисан',
    FluentEmptyActivityFinancialTargetNote: 'Разлог из којих циљана вредност није остварена мора бити дефинисан',
    FluentEmptyProjectChangesActivity: 'Измена процењених укупних трошкова и датума завршетка пројекта мора бити дефинисан',
    FluentEmptyProjectChangesActivityData: 'Измена процењених укупних трошкова или датум завршетка пројекта мора бити дефинисан',
    FluentDuplicateProjectChangesActivityName: 'Постоји дупла активност код измене процењених укупних трошкова и датума завршетка пројекта',
    FluentEmptyProjectChangesActivityName: 'Активност код измене процењених укупних трошкова и датума завршетка пројекта је обавезан податак',
    FluentEmptyProjectChangesEstimateReason: 'Разлози измене трошкова су обавезан податак',
    FluentEmptyProjectChangesDateReason: 'Разлози измене процењених датума су обавезан податак',
    FluentEmptyProjectChanges: 'Измена процењених укупних трошкова пројекта није дефинисана',
    FluentEmptyProjectName: 'Назив пројекта је обавезан податак',
    FluentProjectNameInvalid: 'Недостаје назив пројекта или назив има мање од 5 слова',
    FluentEmptyProposerOrganization: 'Предлагач идеје капиталног пројекта није дефинисан',
    FluentEmptyAuthorizedOrganization: 'Овлашћени предлагач капиталног пројекта није дефинисан',
    FluentInvalidProposerOrganizationFormat: 'Формат предлагача идеје капиталног пројекта није валидан. Да ли сте изабрали предлагача из листе предложених?',
    FluentInvalidEstimateTotal: 'Вредност капиталног пројекта мора бити већа од 20.000.000 евра',
    FluentExpensesSourcesNeedsToBeLessOrEqualToEstimateTotalInDinarsInvalid: 'Потенцијални извори финансирања тотал не може да буде већи од Процењени трошкови - Укупна процењени трошкови у РСД',
    FluentExpensesSourcesNeedsToBeGreaterThanZeroInvalid: 'Потенцијални извори финансирања тотал мора бити већи од 0',
    FluentExpensesSourceNameEmpty: 'Назив извора код потенцијалних извора финансирања мора бити попуњено.',
    FluentInvalidConstructionPeriodInvalid: 'Прелиминарна процена трајања капиталног пројекта мора бити дужа од 11 месеци',
    FluentFeasibilityPredictedSourceInvalid: 'Сви извори који су наведени у тачки 4.2 морају да буду наведени и у тачки 4.4',
    FluentFeasibilityPreparationAmountInvalid: 'Буџет предвиђен у тачки 4.2 не сме да буде већи од износа предвиђеног за припрему пројекта у тачки 4.1.',
    FluentInvalidProposerOrganization: 'Предлагач идеје капиталног пројекта није пронађен у регистру',
    FluentInvalidLocationFormat: 'Формат локације није валидан. Да ли сте изабрали локацију из листе предложених?',
    FluentInvalidLocation: 'Локација није пронађена у регистру',
    FluentDuplicatedLocation: 'Унесене исте локације',
    FluentEmptyLocation: 'Локације нису дефинисане',
    FluentExpenseSourceEmpty: 'Потенцијални извори финансирања треба додати Износ у РСД или Износ у страној валути или Валута тип',
    FluentExpenseSourceZero: 'Потенцијални извори финансирања не могу бити 0',
    FluentExpenseCurrencyMissing: 'Потенцијални извори финансирања морају имати унету валуту',
    FluentProjectDescriptionEmpty: 'Кратак опис (резиме) прелиминарне пројектне идеје опис пројекта није дефинисан',
    FluentPlanCompatibilityEmpty: 'Веза са планским документима није дефинисан',
    FluentEmptyProjectImplementationDetails: 'Да ли је пројекат започео реализацију пре 01.01.2023. мора бити дефинисано',
    FluentEmptyProjectImplementationDetailsStart: 'Стварни датум почетка пројекта мора бити дефинисан',
    FluentInvalidProjectImplementationDetailsStart: 'Стварни датум почетка пројекта није валидан',
    FluentEmptyProjectImplementationDetailsAmount: 'Укупна вредност пројекта у РСД мора бити дефинисана',
    FluentInvalidProjectImplementationDetailsAmount: 'Укупна вредност пројекта у РСД није валидна',
    FluentEmptyResponsiblePeople: 'Одговорна или овлашћена контакт лица нису дефинисан',
    FluentProjectPreparationDepartmentEmpty: 'Одељење надлежно за припрему пројекта менађери нису дефинисани ',
    FluentProjectMonitoringAndImplementationDepartmentManagersEmpty: 'Одељење за праћење и спровођење пројекта манађери нису дефинисани',
    FluentEmptyResponsiblePersonName: 'Име одговорног или овлашћеног контакт лица није дефинисано',
    FluentEmptyResponsiblePersonFunction: 'Функција одговорног или овлашћеног контакт лица није дефинисана',
    FluentReachedResponsiblePersonEmailCountLimit: 'Број електронских пошти одговорног или овлашћеног контакт лица је већи од 3',
    FluentInvalidResponsiblePersonEmail: 'Електронска пошта одговорног или овлашћеног контакт лица није валидна',
    FluentReachedResponsiblePersonPhoneCountLimit: 'Број телефона одговорног или овлашћеног контакт лица је већи од 3',
    FluentInvalidResponsiblePersonPhone: 'Телефон одговорног или овлашћеног контакт лица није валидан',
    FluentEmptyStrategySectorName: 'Назив сектора за политику/стратегије није дефинисан',
    FluentEmptyStrategySectorManager: 'Руководилац сектора за политику/стратегије није дефинисан',
    FluentEmptyCooperationSectorName: 'Назив сектора за ИПА пројекте и међународну сарадњу није дефинисан',
    FluentEmptyCooperationSectorManager: 'Руководилац сектора за ИПА пројекте и међународну сарадњу није дефинисан',
    FluentEmptyPreparationDepartmentName: 'Назив одељења за припрему пројекта није дефинисан',
    FluentEmptyPreparationDepartmentManager: 'Руководилац одељења за припрему пројекта није дефинисан',
    FluentEmptyPreparationDepartmentManagers: 'Менаџери одељења за припрему пројекта нису дефинисани',
    FluentEmptyPreparationDepartmentManagerName: 'Име менаџера одељења за припрему пројекта није дефинисано',
    FluentEmptyPreparationDepartmentManagerFunction: 'Функција менаџера одељења за припрему пројекта није дефинисана',
    FluentReachedPreparationDepartmentManagerEmailCountLimit: 'Број електронских пошти менаџера одељења за припрему пројекта је већи од 3',
    FluentInvalidPreparationDepartmentManagerEmail: 'Електронска пошта менаџера одељења за припрему пројекта није валидна',
    FluentReachedPreparationDepartmentManagerPhoneCountLimit: 'Број телефона менаџера одељења за припрему пројекта је већи од 3',
    FluentInvalidPreparationDepartmentManagerPhone: 'Телефон менаџера одељења за припрему пројекта није валидан',
    FluentEmptyMonitoringDepartmentName: 'Назив одељења за праћење и спровођење пројекта није дефинисан',
    FluentEmptyMonitoringDepartmentManager: 'Руководилац одељења за праћење и спровођење пројекта није дефинисан',
    FluentEmptyMonitoringDepartmentManagerName: 'Име менаџера oдељењa за праћење и спровођење пројекта није дефинисано',
    FluentEmptyMonitoringDepartmentManagerFunction: 'Функција менаџера oдељењa за праћење и спровођење пројекта није дефинисана',
    FluentReachedMonitoringDepartmentManagerEmailCountLimit: 'Број електронских пошти менаџера oдељењa за праћење и спровођење пројекта је већи од 3',
    FluentInvalidMonitoringDepartmentManagerEmail: 'Електронска пошта менаџера oдељењa за праћење и спровођење пројекта није валидна',
    FluentReachedMonitoringDepartmentManagerPhoneCountLimit: 'Број телефона менаџера oдељењa за праћење и спровођење пројекта је већи од 3',
    FluentInvalidMonitoringDepartmentManagerPhone: 'Телефон менаџера oдељењa за праћење и спровођење пројекта није валидан',
    FluentEmptyMonitoringDepartmentManagers: 'Менаџери одељења за праћење и спровођење пројекта нису дефинисани',
    FluentEmptySuggestionCorrection: 'Корекција пројекта није дефинисана',
    FluentEmptySuggestionPostponement: 'Одлагање пројекта није дефинисано',
    FluentEmptySuggestionClosure: 'Гашење пројекта није дефинисано',
    FluentEmptyDelayNote: 'Разлог кашњења је обавезан податак',
    FluentEmptyExpenses: 'Укупни трошкови реализације пројекта су обавезан податак',
    FluentEmptyEstimatedExpense: 'Планирани трошкови код укупних трошкова реализације пројекта је обавезан податак',
    FluentInvalidEstimatedExpense: 'Планирани трошкови код укупних трошкова реализације пројекта није валидан',
    FluentEmptyActualExpense: 'Реализовани трошкови код укупних трошкова реализације пројекта је обавезан податак',
    FluentInvalidActualExpense: 'Реализовани трошкови код укупних трошкова реализације пројекта није валидан',
    FluentEmptyExpensePercent: 'Проценат реализације плана код укупних трошкова реализације пројекта је обавезан податак',
    FluentEInvalidExpensePercent: 'Проценат реализације плана код укупних трошкова реализације пројекта није валидан',
    FluentEmptyExpenseSources: 'Трошкови по изворима финансирања су обавезан податак',
    FluentEmptyExpenseSourceSource: 'Извор код трошкова по изворима финансирања је обавезан податак',
    FluentEmptyExpenseSourceName: 'Назив код трошкова по изворима финансирања је обавезан податак',
    FluentEmptyExpenseDeviationNote: 'Разлози одступања нису дефинисани',
    FluentEmptyOtherNote: 'Образложење није дефинисано',
    FluentPartnershipQuestionEmpty: 'Да ли се капитални пројекат реализује путем јавно-приватног партнерства, односно концесије дефинисане законом којим се уређује јавно-приватно партнерство и концесијa коментар није дефинисан',
    FluentAcceptanceIdeaEmpty: 'Документа развојног планирања коментар није дефинисан',
    FluentPolicyDocumentsEmpty: 'Документа јавних политика коментар није дефинисан',
    FluentOtherDocumentsEmpty: 'Остала планска документа коментар није дефинисан',
    FluentEuPoliticEmpty: 'ЕУ политика коментар није дефинисан',
    FluentInstitutionalFrameworkOtherEmpty: 'Остала лица, кључна министарства и организације нису дефинисана',
    FluentAffectedLocationEmpty: 'Локација пројекта није дефинисана',
    FluentEstimatePreparationEmpty: 'Процењени трошкови припреме пројекта у РСД није дефинисан',
    FluentEstimateRealizationEmpty: 'Процењени трошкови реализације капиталног пројекта у РСД',
    FluentExplanationSectorEmpty: 'Објаснити однос водећег сектора и других сектора у којима ће реализација пројекта имати утицај није дефинисан',
    FluentProjectNameEmpty: 'Назив пројекта је обавезан и мора да има минимум 5 слова',
    FluentEmptyExpenseSourceAmounts: 'Износи код трошкова по изворима финансирања су обавезан податак',
    FluentEmptyDelayProjectApprovedDate: 'Датум одобрења пројекта / Одобрена листа припремљених капиталних пројеката није дефинисан',
    FluentEmptyDelayFinalProjectEndDate: 'Актуелни крај завршетка пројекта није дефинисан',
    FluentInvalidDelayFinalProjectEndDate: 'Актуелни крај завршетка пројекта није валидан',
    FluentEmptyUnpredictedSelection: 'Избор непредвиђених активности није дефинисан',
    FluentEmptyUnpredictedActivities: 'Непредвиђене активности нису дефинисане',
    FluentEmptyUnpredictedActivityName: 'Назив непредвиђене активности није дефинисан',
    FluentDuplicateUnpredictedActivityName: 'Постоји дупла непредвиђена активност',
    FluentDuplicateUnpredictedRealActivityName: 'Постоји непредвиђена активност која има исти назив као планирана активност',
    FluentEmptyUnpredictedActivityExpense: 'Расход непредвиђене активности није дефинисан',
    FluentEmptyUnpredictedComment: 'Образложење за постојање непредвиђених активности је обавезан податак',
    FluentEmptyParticipantOrganization: 'Назив организације код додатних учесника није дефинисан',
    FluentEmptyParticipantName: 'Име и презиме додатног учесника није дефинисано',
    FluentInvalidParticipantEmail: 'Адреса електронске поште код додатног учесника није валидна',
    FluentInvalidParticipantPhone: 'Телефон код додатног учесника није валидан',
    FluentEstimateCommentInvalid: 'Образложење обрачуна процењених трошкова мора бити попуњено.',
    FluentEmptyProjectFormAppropriations: 'Апропријације нису дефинисане',
    FluentEmptyProjectDocumentType: 'Документ мора да има тип',
    FluentEmptyProjectDocumentUnknownType: 'Непознат тип документа',
    FluentExpectedGoalsEmpty: 'Реализације овог пројекта доприноси испуњавању стратешких циљева који су дефинисани није дефинисан',
    FluentAssessment1Empty: 'Реализације овог пројекта доприноси испуњавању стратешких циљева који су дефинисани - Оцена стратешке релевантности није дефинисана',
    FluentImplementationGoalsEmpty: 'Резултати пројекта имају утицаја на спровођење секторских стратегија/програма није дефинисан',
    FluentValidateAssessment2Empty: 'Резултати пројекта имају утицаја на спровођење секторских стратегија/програма - Оцена стратешке релевантности није дефинисана',
    FluentImplementationInternationalEmpty: 'Реализација овог пројекта доприноси испуњавању обавеза из међународних уговора и споразума Републике Србије податак није дефинисан',
    FluentAssessment3Empty: 'Реализација овог пројекта доприноси испуњавању обавеза из међународних уговора и споразума Републике Србије је обавезан податак - Оцена стратешке релевантности није дефинисана',
    FluentImplementationEUEmpty: 'Реализација овог пројекта доприноси испуњавању обавеза из процеса ЕУ интеграција није дефинисан',
    FluentAssessment4Empty: 'Реализација овог пројекта доприноси испуњавању обавеза из процеса ЕУ интеграција је обавезан податак - Оцена стратешке релевантности није дефинисана',
    FluentPopulationEffectEmpty: 'Резултати пројекта имају позитиван ефекат на популацију није дефинисан 1',
    FluentAssessment5Empty: 'Резултати пројекта имају позитиван ефекат на популацију - Оцена стратешке релевантности није дефинисана',
    FluentImplementationEffectEmpty: 'Резултати пројекта имају позитиван ефекат на популацију није дефинисан 2',
    FluentCrossBorderEffectsEmpty: 'Оцена стратешке релевантности није дефинисан',
    FluentUnderdevelopedRegionsEmpty: 'Оцена стратешке релевантности није дефинисан',
    FluentDevastatedAreasEmpty: 'Оцена стратешке релевантности није дефинисан',
    FluentImplementationEnablesEmpty: 'Реализација овог пројекта омогућава није дефинисан',
    FluentOtherAssessment7Empty: 'Оцена стратешке релевантности је није дефинисан 7',
    FluentNotRealizedEmpty: 'Шта би се догодило ако предлог пројекта не би био реализован није дефинисан',
    FluentAssessment8Empty: 'Оцена стратешке релевантности није дефинисан 8',
    FluentProjectObjectivesEmpty: 'Шта је/су циљ(еви) предложеног пројекта? није дефинисан ',
    FluentAssessment9Empty: 'Оцена стратешке релевантности није дефинисан 9',
    FluentPlannedActivitiesEmpty: 'Које су планиране активности, резултати и исходи предложеног пројекта није дефинисан',
    FluentAssessment10Empty: 'Које су планиране активности, резултати и исходи предложеног пројекта није дефинисан - Оцена квалитета није дефинисана',
    FluentPlannedUsersEmpty: 'Ко су планирани корисници пројекта и колико их има није дефинисан',
    FluentAssessment11Empty: 'Ко су планирани корисници пројекта и колико их има није дефинисан - Оцена квалитета није дефинисана',
    FluentPositiveNegativeEmpty: 'Навести све позитивне и негативне утицаје пројекта са аспекта одрживог развоја и климатских промена није дефинисана',
    FluentAssessment12Empty: 'Навести све позитивне и негативне утицаје пројекта са аспекта одрживог развоја и климатских промена је обавезан податак - Оцена квалитета није дефинисана',
    FluentGoalsImportantEmpty: 'Највећи позитиван утицај није дефинисан',
    FluentGoalsOthersEmpty: 'Утиче и на неке друге циљеве није дефинисан',
    FluentNotesEmpty: 'Напомене није дефинисана',
    FluentNoteFinancialAspectsEmpty: 'Процењени укупни трошкови капиталног пројекта износ припреме није дефинисан',
    FluentCapitalRealizationEmpty: 'Процењена средства за реализацију пројекта морају бити дефинисана и већа од 0',
    FluentFeasibilityStudyEmpty: 'Који би буџет био потребан за израду (претходне) студије изводљивости/оправданости није дефинисан',
    FluentFeasibilityStudyBiggerThenTotalExpensesValidation: 'Који би буџет био потребан за израду (претходне) студије изводљивости/оправданости је већи износ од - Процењена средства за припрему пројекта у РСД',
    FluentCapitalRequirementsRiskEmpty: 'Процењени трошкови за сваку годину није дефинисан',
    FluentCapitalRequirementsRiskYearEmpty: 'Процењени трошкови за сваку годину - Фискална година није дефинисан',
    FluentCapitalRequirementsRiskAmountEmpty: 'Процењени трошкови за сваку годину - Потребан износ није дефинисан',
    FluentValidateCapitalRequirementsEqualToEstimateTotalInvalid: 'Укупан збир процењених трошкова за сваку годину треба да буде једнак износу процењених укупних трошкова за припрему и реализацију пројектa.',
    FluentValidateCapitalRequirementsCapitalsSourcesEqualsContextChoice2Invalid: 'Укупан збир - Процењени трошкови за сваку годину реализације пројекта у односу на планирани временски оквир реализације пројекта - није једнак - Процењени трошкови реализације пројекта',
    FluentValidateFundingCapitalsInvalid: 'Процењени трошкови за сваку годину финансирања морају да буду једнаки збиру предвиђених извора (тачка 5)',
    FluentValidateSummaryContextChoiceContextChoice2LessThenContextChoice3Invalid: 'Процењени укупни трошкови пројекта (припрема + реализација / изградња) - не може да буде мањи од збира - Утрошена средства за припрему пројекта и Процењени укупни трошкови пројекта (припрема + реализација / изградња)',
    FluentValidatePredictedSourceEqualToEstimateTotalInvalid: 'Предвиђени извори финансирања није једнак - Подаци о финансијском аспекту предлога пројекта - Укупни трошкови',
    FluentPredictedSourceInRangeOfConstructionPeriodInvalid: ' 1. Процењено трајање пројекта, у месецима мора да буде веће или једнака - 4.3 Процењени трошкови за сваку годину - Фискална година, збиру месеци свих година',
    FluentConstructionPeriodInRangeOfEndPrepartionStartCompletionWorkEndInvalid: 'Завршетак припреме / процене - планирани датум припреме до Завршетка радова / реализације - Планирани датум завршетак је дужи период од Процењено трајање пројекта',
    FluentRiskEmpty: 'Ризик није дефинисан',
    FluentRiskNameEmpty: 'Ризик - Опишите ризик није дефинисан',
    FluentRiskDegreeEmpty: 'Ризик - Процењени степен ризика није дефинисан',
    FluentRiskManagerEmpty: 'Ризик - Како ће се управљати ризиком није дефинисан',
    FluentOperatingTotalEmpty: 'Укупни процењени годишњи оперативни трошкови пројекта није дефинисан',
    FluentOperatingOldEmpty: 'Колико трошкова ће бити покривено из постојећег буџета није дефинисан',
    FluentOperatingNewEmpty: '',
    FluentNewCostsSourcesEmpty: '',
    FluentPreviousTextEmpty: 'Укупни трошкови експропријације се процењују није дефинисан',
    FluentIncomeChoiceEmpty: '',
    FluentIncomeTextRiskEmpty: '',
    FluentIncomeTextWhoManageEmpty: '',
    FluentValidateNewCostsSourcesEqualsOperatingNewInvalid: 'Годишњи оперативни трошкови - Нови оперативни трошкови морају бити износ укупног - Извори додатних оперативних трошкова и трошкова одржавања',
    FluentNewCostsEmpty: 'Извори додатних оперативних трошкова и трошкова одржавања није дефинисан',
    FluentNewCostLocalAmountEmpty: 'Извори додатних оперативних трошкова и трошкова одржавања - Износ у РСД',
    FluentNewCostAmountEmpty: 'Извори додатних оперативних трошкова и трошкова одржавања - Износ у страној валути',
    FluentNewCostCurrencyEmpty: 'Извори додатних оперативних трошкова и трошкова одржавања - Валута',
    FluentIncomeEmpty: 'Приход није дефинисан',
    FluentIncomeYearEmpty: 'Приход - Оперативна година није дефинисана',
    FluentIncomeAmountEmpty: 'Приход - Процењени расходи нису дефинисани',
    FluentPredictedSourceSourcesEmpty: 'Предвиђени извори финансирања',
    FluentPredictedSourceSourcesLocalAmountEmpty: 'Предвиђени извори финансирања - Износ у РСД',
    FluentPredictedSourceSourcesCurrencyEmpty: 'Предвиђени извори финансирања - Валута',
    FluentPredictedSourceSourcesPercentageEmpty: 'Предвиђени извори финансирања - Износ (%)',
    FluentPredictedSourceSourcesProvidedEmpty: 'Предвиђени извори финансирања - Обезбеђено',
    FluentEndPreparationStartEmpty: 'Завршетак припреме / процене - Планирани датум почетка није дефинисан',
    FluentEndPreparationEndEmpty: 'Завршетак припреме / процене - Планирани датум завршетка није дефинисан',
    FluentPublicInvitationStartEmpty: 'Јавни позив за набавку - Планирани датум почетка није дефинисан',
    FluentPublicInvitationEndEmpty: 'Јавни позив за набавку - Планирани датум завршетка није дефинисан',
    FluentAwardContractStartEmpty: 'Додељивање уговора - Планирани датум почетка није дефинисан',
    FluentAwardContractEndEmpty: 'Додељивање уговора - Планирани датум завршетка није дефинисан',
    FluentWapper4StartEmpty: 'Почетак радова / реализације - Планирани датум почетка није дефинисан',
    FluentWapper4EndEmpty: 'Почетак радова / реализације - Планирани датум завршетка није дефинисан',
    FluentCompletionWorksStartEmpty: 'Завршетак радова / реализације - Планирани датум почетка није дефинисан',
    FluentCompletionWorksEndEmpty: 'Завршетак радова / реализације - Планирани датум завршетка није дефинисан',
    FluentProjectOperationalStartEmpty: 'Пројекат постаје оперативан - Планирани датум почетка није дефинисан',
    FluentProjectOperationalEndEmpty: 'Пројекат постаје оперативан - Планирани датум завршетка није дефинисан',
    FluentPublicInvitationEndSmaller: 'Планирани датум завршетка јавног позива за набавку је мањи од планираног датума завшетка припреме.',
    FluentAwardContractEndSmaller: 'Планирани датум завршетка доделе уговора је мањи од планираног датума завршетка јавног позива за набавку.',
    FluentWapper4EndSmaller: 'Планирани датум завршетка почетка радова је мањи од планираног датума завршетка доделе уговора.',
    FluentCompletionWorksEndSmaller: 'Планирани датум завршетка радова је мањи од планираног датума завршетка почетка радова.',
    FluentProjectOperationalEndSmaller: 'Планирани датум завршетка оперативности је мањи од планираног датума завршетка радова.',
    FluentPreviousExperienceEmpty: 'Да ли предлагач пројекта има искуство у реализацији сличних капиталних пројеката није дефинисан',
    FluentPreviousExperienceYesEmpty: 'Ако предлагач има претходно искуство у реализацији сличних пројеката (на пример ‘поновљених’ пројеката као што су клинике или школе) то подразумева висок ниво поверења да предложени пројекат може да буде спроведен адекватно, уколико финансирање буде одобрено. Предлагач треба да наведе сличне пројекте које је успешно реализовао у претходних пет година није дефисан',
    FluentPreviousExperienceNoEmpty: 'Ако није било претходног искуства или предложени пројекат садржи значајан ниво иновација, то ће се сматрати потенцијалним ризиком у смислу успешног спровођења. У том случају, предлагач треба да опише мере (на пример, ангажовање стручног особља или екстерних консултаната) које ће ублажити или отклонити потенцијалне ризике у реализацији пројекта није дефинисан',
    FluentAgencyCommunalEmpty: 'Навести агенције, јавна комунална предузећа и регулаторне институције (имаоци јавних овлашћења) које обављају делатност од значаја за реализацију капиталног пројекта није дефинисан',
    FluentInterestHoldersEmpty: 'Навести носиоце интереса у пројекту уз информацију о томе да ли су консултовани у погледу овог капиталног пројекта није дефинисан',
    FluenteneralRiskEmpty: 'Навести потенцијалне опште ризике је обавезан податак',
    FluentGeneralRiskWhoManageEmpty: 'Навести потенцијалне процене ко ће се управљати ризиком је обавезан податак',
    FluentEnvironmentQuestionsEmpty: 'Ставка 5.6. - Навести значајна питања утицаја на животну средину није дефинисан',
    FluentLocalGovermentEmpty: 'Надлежно министарство/јединица локалне самоуправе односно аутономне покрајине није дефинисан',
    FluentImportantSectorEmpty: 'Навести водећи сектор је обавезан податак',
    FluentOtherSectorsEmpty: 'Резултати пројекта имају утицај на достизањe циљева или испуњавањe обавеза из - Други сектори је обавезан податак',
    FluentPoliticsStrategySectorNameEmpty: 'Ставка 1. - Сектор за политике/стратегије - назив сектора / одељења  није дефинисан',
    FluentInternationalCooperationSectorNameEmpty: 'Сектор за политике/стратегије -Руководилац  није дефинисан',
    FluentPoliticsStrategySectorManagerEmpty: 'Сектор надлежан за ИПА пројекте и међународну сарадњу - Назив сектора / одељења није дефинисан',
    FluentProjectPreparationDepartmentNameEmpty: 'Одељење за праћење и спровођење пројекта - Назив сектора / одељења није дефинисан',
    FluentProjectPreparationDepartmentManagerEmpty: 'Одељење за праћење и спровођење пројекта - Руководилац није дефинисан',
    FluentInternationalCooperationSectorManagerEmpty: 'Сектор надлежан за ИПА пројекте и међународну сарадњу - Руководилац је није дефинисан',
    FluentProjectMonitoringAndImplementationDepartmentNameEmpty: 'Одељење надлежно за припрему пројекта - Одељење није дефинисан',
    FluentProjectMonitoringAndImplementationDepartmentManagerEmpty: 'Одељење за праћење и спровођење пројекта - Руководилац није дефинисан',
    FluentProcurementTextEmpty: 'Врста услуга није дефинисана',
    FluentProcurementText2Empty: 'Набавка опреме није дефинисана',
    FluentProcurementText3Empty: 'Инфраструктурни пројекти/набавка непокретности није дефинисана',
    FluentConstructionChoiceEmpty: 'Да ли постоји потреба за грађевинским радовима у вези набавке и постављања опреме није дефинисан',
    FluentScopeTextEmpty: 'Кохерентан са циљевима пројекта - недостаје коментар',
    FluentScopeText2Empty: 'Сагласан са циљевима развојних планова - недостаје коментар',
    FluentScopeText3Empty: 'Усаглашен са регулаторним и законским оквиром - недостаје коментар',
    FluentScopeText4Empty: 'Има оквирни план реализације - недостаје коментар',
    FluentScopeText5Empty: 'Има идентификоване клијенте/купце или кориснике пројекта - недостаје коментар',
    FluentScopeText6Empty: 'Има припремљену пројектно-тендерску документацију - недостаје коментар',
    FluentScopeText7Empty: 'Има идентификоване критичне тачке пројекта - недостаје коментар',
    FluentScopeText8Empty: 'Има идентификоване потенцијалне ризике и проблеме - недостаје коментар',
    FluentScopeText9Empty: 'Има дефинисане механизме за решавање/ублажавање потенцијалних ризика/проблема - недостаје коментар',
    FluentScopeText10Empty: 'Има дефинисане људске/институционалне или материјално/техничке ресурсе потребне за реализацију пројекта - недостаје коментар',
    FluentScopeText11Empty: 'Има Предходну студију изводљивости/оправданости - недостаје коментар',
    FluentScopeText12Empty: 'Има јасно дефинисане улоге и одговорности - недостаје коментар',
    FluentActivityInfrastructureCompletionDateMonthEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYearEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonthEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYearEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth4Empty: 'Претходна Студија изводљивости (уколико је потребна) - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear4Empty: 'Претходна Студија изводљивости (уколико је потребна) - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth4Empty: 'Претходна Студија изводљивости (уколико је потребна) - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear4Empty: 'Претходна Студија изводљивости (уколико је потребна) - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth5Empty: 'Студија изводљивости /оправданости - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear5Empty: 'Студија изводљивости /оправданости - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth5Empty: 'Студија изводљивости /оправданости - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear5Empty: 'Студија изводљивости /оправданости - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth6Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear6Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth6Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear6Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth7Empty: 'Процена утицаја на животну средину (уколико је потребна) - Датум завршетка активности - Месец није дефинисан (тачка 3.3)',
    FluentActivityInfrastructureCompletionDateYear7Empty: 'Процена утицаја на животну средину (уколико је потребна) - Датум завршетка активности - Година није дефинисана (тачка 3.3)',
    FluentActivityInfrastructureDocumentDateMonth7Empty: 'Процена утицаја на животну средину (уколико је потребна) - Датум израде документа - Месец није дефинисан (тачка 3.3)',
    FluentActivityInfrastructureDocumentDateYear7Empty: 'Процена утицаја на животну средину (уколико је потребна) - Датум израде документа - Година није дефинисана (тачка 3.3)',
    FluentActivityInfrastructureCompletionDateMonth8Empty: 'Генерални пројекат - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear8Empty: 'Генерални пројекат - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth8Empty: 'Генерални пројекат - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear8Empty: 'Генерални пројекат - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth9Empty: 'Идејно решење - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear9Empty: 'Идејно решење - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth9Empty: 'Идејно решење - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear9Empty: 'Идејно решење - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth10Empty: 'Идејни пројекат - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear10Empty: 'Идејни пројекат - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth10Empty: 'Идејни пројекат - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear10Empty: 'Идејни пројекат - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth11Empty: 'Пројекат за грађевинску дозволу - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear11Empty: 'Пројекат за грађевинску дозволу - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth11Empty: 'Пројекат за грађевинску дозволу - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear11Empty: 'Пројекат за грађевинску дозволу - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth13Empty: 'Грађевинска дозвола - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear13Empty: 'Грађевинска дозвола - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth13Empty: 'Грађевинска дозвола - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear13Empty: 'Грађевинска дозвола - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth12Empty: 'Пројекат за извођење - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear12Empty: 'Пројекат за извођење - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth12Empty: 'Пројекат за извођење - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear12Empty: 'Пројекат за извођење - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth14Empty: 'Тендерска документација - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear14Empty: 'Тендерска документација - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth14Empty: 'Тендерска документација - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear14Empty: 'Тендерска документација - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureCompletionDateMonth15Empty: 'Набавка је део ширег програма - Датум завршетка активности - Месец није дефинисан',
    FluentActivityInfrastructureCompletionDateYear15Empty: 'Набавка је део ширег програма - Датум завршетка активности - Година није дефинисана',
    FluentActivityInfrastructureDocumentDateMonth15Empty: 'Набавка је део ширег програма - Датум израде документа - Месец није дефинисан',
    FluentActivityInfrastructureDocumentDateYear15Empty: 'Набавка је део ширег програма - Датум израде документа - Година није дефинисана',
    FluentActivityInfrastructureChoiceEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу није дефинисан',
    FluentActivityInfrastructureChoice2Empty: 'Аквизиција земљишта (Формално доступно земљиште) није дефинисан',
    FluentActivityInfrastructureChoice3Empty: 'Претходна Студија изводљивости (уколико је потребна) није дефинисан',
    FluentActivityInfrastructureChoice4Empty: 'Студија изводљивости /оправданости није дефинисан',
    FluentActivityInfrastructureChoice5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) није дефинисан',
    FluentActivityInfrastructureChoice6Empty: 'Процена утицаја на животну средину (уколико је потребна) није дефинисан',
    FluentActivityInfrastructureChoice7Empty: 'Генерални пројекат није дефинисан',
    FluentActivityInfrastructureChoice8Empty: 'Идејно решење није дефинисан',
    FluentActivityInfrastructureChoice9Empty: 'Идејни пројекат није дефинисан',
    FluentActivityInfrastructureChoice10Empty: 'Пројекат за грађевинску дозволу није дефинисан',
    FluentActivityInfrastructureChoice11Empty: 'Грађевинска дозвола није дефинисан',
    FluentActivityInfrastructureChoice12Empty: 'Пројекат за извођење није дефинисан',
    FluentActivityInfrastructureChoice13Empty: 'Тендерска документација није дефинисан',
    FluentActivityDateEmpty: 'Обезбеђени сви предуслови за реализацију на страни Предлагача идеје капиталног пројекта - Датум завршетка активности није дефинисан',
    FluentActivityTextEmpty: 'Навести предуслове за „Да” или „Не” " - Коментар није дефинисан',
    FluentActivityDate2Empty: 'Услугу Предлагач идеје обавља сам - Датум завршетак активности није дефинисан',
    FluentActivityText2Empty: 'Услугу Предлагач идеје обавља сам - Коментар није дефинисан',
    FluentActivityDate3Empty: 'Услугу Предлагач идеје обавља са другим државним органима - Датум завршетка активности није дефинисан',
    FluentActivityText3Empty: 'Услугу Предлагач идеје обавља са другим државним органима - Дефинисани или идентификовани државни органи није дефинисан',
    FluentActivityDate4Empty: 'Навести други начин за реализацију услуга - Датум завршетка активности није дефинисан',
    FluentActivityText4Empty: 'Навести други начин за реализацију услуга - Коментар није дефинисан',
    FluentActivityCommentEmpty: 'Молимо да о напред наведеном доставите разјашњења или додатне информације, уколико сматрате да је то потребно није дефинисан',
    FluentActivityEquipmentChoiceEmpty: 'Дефинисане специфичне карактеристике предметнe набавке опреме није дефинисан',
    FluentActivityEquipmentDateEmpty: 'Дефинисане специфичне карактеристике предметнe набавке опреме - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentTextEmpty: 'Дефинисане специфичне карактеристике предметнe набавке опреме - Коментар није дефинисан',
    FluentActivityEquipmentChoice2Empty: 'Дефинисане количине предметнe набавке опреме није дефинисан није дефинисан',
    FluentActivityEquipmentDate2Empty: 'Дефинисане количине предметнe набавке опреме - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText2Empty: 'Дефинисане количине предметнe набавке опреме - Коментар није дефинисан',
    FluentActivityEquipmentChoice3Empty: 'Постојање тендерске документације није дефинисан није дефинисан',
    FluentActivityEquipmentDate3Empty: 'Постојање тендерске документације - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText3Empty: 'Постојање тендерске документације - Коментар није дефинисан',
    FluentActivityEquipmentChoice4Empty: 'Употреба набављене опреме захтева грађевинске радове код предлагача идеје капиталног пројекта није дефинисан',
    FluentActivityEquipmentDate4Empty: 'Употреба набављене опреме захтева грађевинске радове код предлагача идеје капиталног пројекта - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText4Empty: 'Употреба набављене опреме захтева грађевинске радове код предлагача идеје капиталног пројекта - Коментар није дефинисан',
    FluentActivityEquipmentChoice5Empty: 'Средста за грађевинске радове обезбеђена (уколико су потребни) није дефинисан није дефинисан',
    FluentActivityEquipmentDate5Empty: 'Средста за грађевинске радове обезбеђена (уколико су потребни) - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText5Empty: 'Средста за грађевинске радове обезбеђена (уколико су потребни) - Коментар није дефинисан',
    FluentActivityEquipmentChoice6Empty: 'Обезбеђени грађевински предуслови за успешну инсталацију предметне набавке (ако је применљиво) није дефинисан',
    FluentActivityEquipmentDate6Empty: 'Обезбеђени грађевински предуслови за успешну инсталацију предметне набавке (ако је применљиво) - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText6Empty: 'Обезбеђени грађевински предуслови за успешну инсталацију предметне набавке (ако је применљиво) - Коментар није дефинисан',
    FluentActivityEquipmentChoice7Empty: 'Употреба набављене опреме захтева техничко/технолошка унапређења код предлагача идеје капиталног пројекта није дефинисан',
    FluentActivityEquipmentDate7Empty: 'Употреба набављене опреме захтева техничко/технолошка унапређења код предлагача идеје капиталног пројекта - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText7Empty: 'Употреба набављене опреме захтева техничко/технолошка унапређења код предлагача идеје капиталног пројекта - Коментар није дефинисан',
    FluentActivityEquipmentChoice8Empty: 'Обезбеђена средства за стварање техничко/технолошких предуслова за коришћење опреме није дефинисан',
    FluentActivityEquipmentDate8Empty: 'Обезбеђена средства за стварање техничко/технолошких предуслова за коришћење опреме - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText8Empty: 'Обезбеђена средства за стварање техничко/технолошких предуслова за коришћење опреме - Коментар није дефинисан',
    FluentActivityEquipmentChoice9Empty: 'Набавка је део ширег програма није дефинисан',
    FluentActivityEquipmentDate9Empty: 'Набавка је део ширег програма - Датум завршетка активности није дефинисан',
    FluentActivityEquipmentText9Empty: 'Набавка је део ширег програма - Коментар није дефинисан',
    FluentActivityCommentEquipmentEmpty: 'Наведите појашњења / додатне информације о горе наведеној техничкој документацији, посебно за пројекте реконструкције постојећих објеката није дефинисан',
    FluentIdentificationOptionEmpty: 'Идентификација опција - Да ли су анализиране различите инвестиционе опције нису дефинисане ',
    FluentIdentificationOptionScenario1Empty: 'Сценарио „уради ништа” - какве ће се могућности пропустити у случају овог сценарија није дефинисан',
    FluentIdentificationOptionScenario2Empty: 'Сценарио „уради минимум” - који минимални напор је потребан да би се постигли циљеви нису дефинисани',
    FluentIdentificationOptionScenario3Empty: 'Сценарио „уради нешто” - које су различите опције анализиране и зашто су искључене нису дефинисане',
    FluentIdentificationOptionScenario4Empty: 'Сценарио „учинити најпожељније није дефинисан',
    FluentInvestmentCommentEmpty: 'У одељку испод навести и образложити све додатне информације о горе наведеном које сматрате неопходним за процену спремности, а тичу се техничког аспекта пројекта није дефинисан',
    FluentActivityInfrastructureTextEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу није дефинисан',
    FluentActivityInfrastructureDateEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText2Empty: 'Аквизиција земљишта (Формално доступно земљиште) није дефинисан',
    FluentActivityInfrastructureDate2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Датум израде документа није дефинисан',
    FluentActivityCompletionDateInfrastructure2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText3Empty: 'Студија изводљивости /оправданости није дефинисан',
    FluentActivityInfrastructureDate3Empty: 'Студија изводљивости /оправданости - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText4Empty: 'Претходна Студија изводљивости (уколико је потребна) није дефинисан',
    FluentActivityInfrastructureDate4Empty: 'Претходна Студија изводљивости (уколико је потребна) - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) није дефинисан',
    FluentActivityInfrastructureDate5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText6Empty: 'Процена утицаја на животну средину (уколико је потребна) није дефинисан',
    FluentActivityInfrastructureDate6Empty: 'Процена утицаја на животну средину (уколико је потребна) - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText7Empty: 'Генерални пројекат није дефинисан',
    FluentActivityInfrastructureDate7Empty: 'Генерални пројекат - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText8Empty: 'Идејно решење није дефинисан',
    FluentActivityInfrastructureDate8Empty: 'Идејно решење - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText9Empty: 'Идејни пројекат није дефинисан',
    FluentActivityInfrastructureDate9Empty: 'Идејни пројекат - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText10Empty: 'Грађевинска дозвола није дефинисан',
    FluentActivityInfrastructureCreationDate10Empty: 'Грађевинска дозвола - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText11Empty: 'Пројекат за извођење није дефинисан',
    FluentActivityInfrastructureDate11Empty: 'Пројекат за извођење - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText12Empty: 'Тендерска документација није дефинисан',
    FluentActivityInfrastructureDate12Empty: 'Тендерска документација - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText13Empty: 'Тендерска документација није дефинисан',
    FluentActivityInfrastructureDate13Empty: 'Тендерска документација - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureText14Empty: 'Набавка је део ширег програма није дефинисан',
    FluentActivityInfrastructureDate14Empty: 'Набавка је део ширег програма - Датум завршетка активности није дефинисан',
    FluentActivityInfrastructureChoice14Empty: 'Набавка је део ширег програма није дефинисан',
    FluentInstitutionalChoiceEmpty: 'Именован је инвеститор или други надлежни орган није дефинисан',
    FluentInstitutionalTextEmpty: 'Именован је инвеститор или други надлежни орган није дефинисан - Навести који није дефинисан',
    FluentInstitutionalChoice2Empty: 'Јавно приватно партнерство (уколико постоји) није дефинисан',
    FluentInstitutionalText2Empty: 'Јавно приватно партнерство (уколико постоји) - Навести који није дефинисан',
    FluentInstitutionalChoice3Empty: 'Постоји прекогранична сарадња није дефинисан',
    FluentInstitutionalText3Empty: 'Постоји прекогранична сарадња - Описати каквa врстa координације постоји између земаља и/или са руководиоцем пројекта није дефинисан',
    FluentInstitutionalChoice4Empty: 'Постојећа Јединица за спровођење Пројекта- PIU / Партнерство за спровођење пројекта није дефинисан',
    FluentInstitutionalText4Empty: 'Постојећа Јединица за спровођење Пројекта- PIU / Партнерство за спровођење пројекта - Навести који није дефинисан',
    FluentInstitutionalChoice5Empty: 'Основана нова Јединица/партнерство за спровођење пројеката није дефинисан',
    FluentInstitutionalText5Empty: 'Основана нова Јединица/партнерство за спровођење пројеката - Навести који није дефинисан',
    FluentInstitutionalChoice6Empty: 'Ангажовани особље (изван PIU) са искуством пројектног корисника одговорног за операције није дефинисан',
    FluentInstitutionalText6Empty: 'Ангажовани особље (изван PIU) са искуством пројектног корисника одговорног за операције - Навести који није дефинисан',
    FluentInstitutionalChoice7Empty: 'Постојећи регионални/локални орган или партнерски конзорцијум је пројектни оператор није дефинисан',
    FluentInstitutionalText7Empty: 'Постојећи регионални/локални орган или партнерски конзорцијум је пројектни оператор - Навести који није дефинисан',
    FluentInstitutionalChoice8Empty: 'Нови корисник пројекта одговоран за оперативни период није дефинисан',
    FluentInstitutionalText8Empty: 'Нови корисник пројекта одговоран за оперативни период - Навести који није дефинисан',
    FluentInstitutionalListActivityCommentEmpty: 'О напред наведеном доставите разјашњења или додатне информације, уколико сматрате да је то потребно није дефинисан',
    FluentContextChoiceEmpty: 'Утрошена средства за припрему пројекта - Износ није дефинисан',
    FluentContextTextEmpty: 'Утрошена средства за припрему пројекта - Коментар није дефинисан',
    FluentContextChoice2Empty: 'Процењени трошкови реализације пројекта - Износ није дефинисан',
    FluentContextText2Empty: 'Процењени трошкови реализације пројекта - Коментар није дефинисан',
    FluentContextChoice3Empty: 'Процењени укупни трошкови пројекта (припрема + реализација / изградња) - Износ није дефинисан',
    FluentContextText3Empty: 'Процењени укупни трошкови пројекта (припрема + реализација / изградња) - Коментар није дефинисан',
    FluentContextChoice4Empty: '% трошкова који се финансирају кроз грант - Износ није дефинисан',
    FluentContextText4Empty: '% трошкова који се финансирају кроз грант - Коментар није дефинисан',
    FluentContextChoice5Empty: '% трошкова који се обезбеђују из кредита - Износ није дефинисан',
    FluentContextText5Empty: '% трошкова који се обезбеђују из кредита - Коментар није дефинисан',
    FluentContextChoice6Empty: 'Капацитет задуживања (кредитна способност) власника/оператора инфраструктуре - Износ није дефинисан',
    FluentContextText6Empty: 'Капацитет задуживања (кредитна способност) власника/оператора инфраструктуре - Коментар није дефинисан',
    FluentContextChoice7Empty: 'Процењена вредност оперативних трошкова - Износ није дефинисан',
    FluentContextText7Empty: 'Процењена вредност оперативних трошкова - Коментар није дефинисан',
    FluentContextChoice8Empty: 'Процењена Интерна стопа профитабилности (ако је доступна) - Износ није дефинисан',
    FluentContextText8Empty: 'Процењена Интерна стопа профитабилности (ако је доступна) - Коментар није дефинисан',
    FluentPlanedDatesPublicInvitationStartEmpty: 'Јавни позив за набавку - Циљани датум почетка',
    FluentPlanedDatesPublicInvitationEndEmpty: 'Јавни позив за набавку - Циљани датум завршетка',
    FluentPlanedDatesAwardContractStartEmpty: 'Додељивање уговора - Циљани датум почетка',
    FluentPlanedDatesAwardContractEndEmpty: 'Додељивање уговора - Циљани датум завршетка',
    FluentPlanedDatesStartWorksStartEmpty: 'Почетак радова / реализације - Циљани датум почетка',
    FluentPlanedDatesStartWorksEndEmpty: 'Почетак радова / реализације - Циљани датум завршетка',
    FluentPlanedDatesCompletionWorksStartEmpty: 'Завршетак радова / реализације - Циљани датум почетка',
    FluentPlanedDatesCompletionWorksEndEmpty: 'Завршетак радова / реализације - Циљани датум завршетка',
    FluentPlanedDatesProjectOperationalStartEmpty: 'Пројекат постаје оперативан - Циљани датум почетка',
    FluentPlanedDatesProjectOperationalEndEmpty: 'Пројекат постаје оперативан - Циљани датум завршетка',
    FluentSocioEconomicContextFinancialCommentEmpty: 'Навести појашњења / додатне информације о горе наведеном за које сматрате да су неопходне није дефинисан',
    FluentCapitalRequirementsCapitalsEmpty: 'Процењени трошкови за сваку годину реализације пројекта у односу на планирани временски оквир реализације пројекта није дефинисана',
    FluentCapitalRequirementsCapitalsYearEmpty: 'Процењени трошкови за сваку годину реализације пројекта у односу на планирани временски оквир реализације пројекта - Фискална година није дефинисана',
    FluentCapitalRequirementsCapitalsAmountEmpty: 'Процењени трошкови за сваку годину реализације пројекта у односу на планирани временски оквир реализације пројекта - Износ није дефинисан',
    FluentCapitalRequirementsRiskInRangeOfConstructionPeriodInvalid: 'Процењени трошкови за сваку годину - број година се не поклапа са процењеним трајањем пројекта у месецима',
    FluentFoundingSourceEmpty: 'Предвиђени извори финансирања није дефинисан',
    FluentFoundingSourceAmountEmpty: 'Предвиђени извори финансирања - Износ у РСД није дефинисан',
    FluentFoundingSourceCurrencyEmpty: 'Предвиђени извори финансирања - Валута није дефинисана',
    FluentFoundingSourceGuaranteedAmountEmpty: 'Предвиђени извори финансирања - Обезбеђено није дефинисан ',
    FluentAirQualityConstructionPhaseEmpty: 'Квалитет ваздуха - Фаза изградње',
    FluentAirQualityWorkPhaseEmpty: 'Квалитет ваздуха - Фаза рада',
    FluentWaterQualityConstructionPhaseEmpty: 'Квалитет воде - Фаза изградње',
    FluentWaterQualityWorkPhaseEmpty: 'Квалитет воде - Фаза рада',
    FluentLandscapeConstructionPhaseEmpty: 'Пејзаж - Фаза изградње',
    FluentLandscapeWorkPhaseEmpty: 'Пејзаж - Фаза рада',
    FluentNoiseConstructionPhaseEmpty: 'Бука - Фаза изградње',
    FluentNoiseWorkPhaseEmpty: 'Бука - Фаза рада',
    FluentSoilConstructionPhaseEmpty: 'Земљиште - Фаза изградње',
    FluentSoilWorkPhaseEmpty: 'Земљиште - Фаза рада',
    FluentGroundwaterConstructionPhaseEmpty: 'Подземне воде - Фаза изградње',
    FluentGroundwaterWorkPhaseEmpty: 'Подземне воде - Фаза рада',
    FluentFloraFaunaConstructionPhaseEmpty: 'Флора и фауна - Фаза изградње',
    FluentFloraFaunaWorkPhaseEmpty: 'Флора и фауна - Фаза рада',
    FluentEnvironmentChoiceEmpty: 'Да ли пројектована инфраструктура утиче на еколошки осетљива подручја (Натура2000 итд.) није дефинисан',
    FluentEnvironmentCommentEmpty: 'Да ли пројектована инфраструктура утиче на еколошки осетљива подручја (Натура2000 итд.) - Коментар није дефинисан',
    FluentEnvironmentChoice3Empty: 'Да ли пројектована инфраструктура утиче на ублажавање климатских промена или доприноси њиховом прилагођавању није дефинисан',
    FluentEfficiencyDegreeEmpty: 'Енергетска ефикасност - Повећање степена енергетске ефикасности у случају реконструкције није дефинисан',
    FluentEfficiencyMinimumEmpty: 'Енергетска ефикасност - Повећање степена енергетске ефикасности у случају реконструкције није дефинисан',
    FluentEfficiencyOtherEmpty: 'Енергетска ефикасност - Повећање степена енергетске ефикасности у случају реконструкције није дефинисан',
    FluentEnvironmentComment2Empty: 'Наведите појашњења / додатне информације о горе наведеном за које сматрате да су неопходне није дефинисан',
    FluentProjectRisksEmpty: 'Подаци о прелиминарним ризицима пројекта није дефинисан',
    FluentProjectRisksRiskEmpty: 'Подаци о прелиминарним ризицима пројекта - Ризик није дефинисан',
    FluentProjectRisksResponsibleEmpty: 'Подаци о прелиминарним ризицима пројекта - Надлежан за тај ризик није дефинисан',
    FluentProjectRisksProbabilityEmpty: 'Подаци о прелиминарним ризицима пројекта - Вероватноћа реализације ризика није дефинисан ',
    FluentProjectRisksMeasuresEmpty: 'Подаци о прелиминарним ризицима пројекта - Мере за ублажавање-избегавање-сучељавање није дефинисан',
    FluentConciseSummaryEmpty: 'Сажет приказ (резиме) наведених података са прелиминарном оценом Овлашћеног предлагача о степену спремности пројекта није дефинисан',
    FluentProjectIdentificationEmpty: 'Прелиминарна оцена - Идентификација пројекта',
    FluentTechnicalAspectEmpty: 'Прелиминарна оцена - Технички аспект',
    FluentInstitutionalFrameworkEmpty: 'Прелиминарна оцена - Институционални оквир',
    FluentFinancialAspectEmpty: 'Прелиминарна оцена - Економско-финансијски аспект',
    FluentEnvironmentalAssessmentEmpty: 'Прелиминарна оцена - Процена утицаја на животну средину',
    FluentPreliminaryRisksEmpty: 'Прелиминарна оцена - Прелиминарни ризици',
    FluentResponsiblePeopleEmpty: 'Одговорна или овлашћена контакт лица',
    FluentAdminFinancialOpinionEmpty: 'Мишљење о финансијском и реализационом аспекту пројекта',
    FluentPublicInvitationEmpty: 'Веза са документима развојног планирања и/или документима јавних политика',
    FluentProjectRelevanceEmpty: 'Релевантност пројекта није дефинисана',
    FluentActivityChoiceEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу није дефинисан',
    FluentActivityCompletionDateEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocumentEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - датум израде документа',
    FluentActivityChoice2Empty: 'Аквизиција земљишта (Формално доступно земљиште) није дефинисан',
    FluentActivityCompletionDate2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - датум израде документа није дефинисан',
    FluentActivityChoice3Empty: 'Претходна студија оправданости (уколико је потребна) није дефинисан',
    FluentValidateActivityChoice3Empty: 'Услугу Предлагач идеје обавља са другим државним органима је обавезан податак',
    FluentActivityCompletionDate3Empty: 'Претходна студија оправданости (уколико је потребна) - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument3Empty: 'Претходна студија оправданости (уколико је потребна) - датум израде документа није дефинисан',
    FluentActivityChoice4Empty: 'Студија оправданости није дефинисан',
    FluentActivityCompletionDate4Empty: 'Студија оправданости - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument4Empty: 'Студија оправданости - датум израде документа није дефинисан',
    FluentActivityChoice5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) није дефинисан',
    FluentActivityCompletionDate5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - датум израде документа није дефинисан',
    FluentActivityChoice6Empty: 'Процена утицаја на животну средину (уколико је потребна) није дефинисан',
    FluentActivityCompletionDate6Empty: 'Процена утицаја на животну средину (уколико је потребна) - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument6Empty: 'Процена утицаја на животну средину (уколико је потребна) - датум израде документа није дефинисан',
    FluentActivityChoice7Empty: 'Генерални пројекат није дефинисан',
    FluentActivityCompletionDate7Empty: 'Генерални пројекат - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument7Empty: 'Генерални пројекат - датум израде документа није дефинисан',
    FluentActivityChoice8Empty: 'Идејно решење није дефинисан',
    FluentActivityCompletionDate8Empty: 'Идејно решење - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument8Empty: 'Идејно решење - датум израде документа није дефинисан',
    FluentActivityChoice9Empty: 'Идејни пројекат није дефинисан',
    FluentActivityCompletionDate9Empty: 'Идејни пројекат - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument9Empty: 'Идејни пројекат - датум израде документа није дефинисан',
    FluentActivityChoice10Empty: 'Пројекат за грађевинску дозволу није дефинисан',
    FluentActivityCompletionDate10Empty: 'Пројекат за грађевинску дозволу - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument10Empty: 'Пројекат за грађевинску дозволу - датум израде документа није дефинисан',
    FluentActivityChoice11Empty: 'Грађевинска дозвола није дефинисан',
    FluentActivityCompletionDate11Empty: 'Грађевинска дозвола - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument11Empty: 'Грађевинска дозвола - датум израде документа није дефинисан',
    FluentActivityChoice12Empty: 'Пројекат за извођење није дефинисан',
    FluentActivityCompletionDate12Empty: 'Пројекат за извођење - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument12Empty: 'Пројекат за извођење - датум израде документа није дефинисан',
    FluentActivityChoice13Empty: 'Тендерска документација није дефинисан',
    FluentActivityCompletionDate13Empty: 'Тендерска документација - датум завршетка активности није дефинисан',
    FluentActivityCreationDateDocument13Empty: 'Тендерска документација - датум завршетка активности није дефинисан',
    FluentPlanningDocumentationActivityTextEmpty: 'Да ли је спроведен архитектонски конкурс у складу са законом који уређује планирање и изградњу - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText2Empty: 'Аквизиција земљишта (Формално доступно земљиште) - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText3Empty: 'Претходна студија оправданости (уколико је потребна) - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText4Empty: 'Студија оправданости - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText5Empty: 'Одобрење Завода за заштиту споменика културе (уколико је потребно) - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText6Empty: 'Процена утицаја на животну средину (уколико је потребна) - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText7Empty: 'Генерални пројекат - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText8Empty: 'Идејно решење - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText9Empty: 'Идејни пројекат - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText10Empty: 'Пројекат за грађевинску дозволу - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText11Empty: 'Грађевинска дозвола - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText12Empty: 'Пројекат за извођење - Коментар није дефинисан',
    FluentPlanningDocumentationActivityText13Empty: 'Тендерска документација - Коментар није дефинисан',
    FluentPlanCompatibilityPublicInvitationEmpty: 'Веза са документима развојног планирања и/или документима јавних политика',
    FluentPlanCompatibilityProjectRelevanceEmpty: 'Релевантност пројекта није дефинисана',
    FluentPlanCompatibilityStartEmpty: 'Процењена година почетка реализације',
    FluentPlanCompatibilityEndEmpty: 'Процењена година завршетка реализације није дефинисан није дефинисан',
    FluentImportantFinancialCommentEmpty: 'Наведите појашњења / додатне информације о горе наведеном за које сматрате да су неопходне није дефинисан није дефинисано',
    FluentImportantProjectReadinessEmpty: 'Недостаје коментар за процену степена спремности пројекта',
    FluentImportantProjectReadinessAssessmentEmpty: 'Ниво спремности у процени степена спремности није дефинисан (тачка 6)',
    FluentEmptyImplementationComment: 'Коментар овлашћеног предлагача капиталног пројекта мора бити попуњен',
    FluentStartEmpty: '"Процењена година почетка реализације" мора бити попуњено',
    FluentEndEmpty: '"Процењена година завршетка реализације" мора бити попуњено',
    // unknown errors
    UnRetrievePagedProjects: 'Непозната грешка приликом добијања листе пројеката',
    UnRetrievePagedProjectDocuments: 'Непозната грешка приликом добијања листе докумената',
    UnRetrieveProjectDocument: 'Непозната грешка приликом добијања документа',
    UnProjectCreate: 'Непозната грешка приликом креирања пројекта',

    UnUpdateProject: 'Непозната грешка приликом ажурирања пројекта',
    UnProjectPhaseStatusUpdate: 'Непозната грешка приликом ажурирања статуса фазе',
    UnProjectPhaseUpdate: 'Непозната грешка приликом ажурирања фазе',
    UnRetrieveProject: 'Непозната грешка приликом добијања пројекта',
    UnRetrieveForm: 'Непозната грешка приликом добијања обрасца',
    UnUploadProjectDocument: 'Непозната грешка приликом додавања документа',
    UnUpdateProjectDocumentRevision: 'Непозната грешка приликом ажурирања заштићеног линка',
    UnSubmitProjectForm: 'Непозната грешка приликом ажурирања обрасца',
    UnEvaluateProjectForm: 'Непозната грешка приликом оцењивања обрасца',
    UnRetrieveProjectPhases: 'Непозната грешка приликом добијања етапа пројекта',
    UnRetrieveProjectOrganizations: 'Непозната грешка приликом добијања организација',
    UnSetProjectOrganizations: 'Непозната грешка приликом ажурирања организација',
    UnCreateProjectList: 'Непозната грешка приликом слања листе комисији',
    UnRetrieveProjectLists: 'Непозната грешка приликом добијања листе пројеката',
    UnRetrieveProjectList: 'Непозната грешка приликом детаља листе пројеката',
    UnSetProjectAppropriations: 'Непозната грешка приликом ажурирања апропријација',
    UnRetrieveProjectAppropriations: 'Непозната грешка приликом добијања апропријација пројекта',
    UnUploadProjectDocumentRevision: 'Непозната грешка приликом додавања ревизије документа',
    UnRetrieveProjectDocumentRevisions: 'Непозната грешка приликом добијања ревизија документа',
    UnRemoveProjectDocument: 'Непозната грешка приликом брисања документа',
    UnRetrieveProjectSuccessKeyIndicators: 'Непозната грешка приликом добијања КПУ података',
    // db errors
    DbRetrievePagedProjects: 'Грешка приликом добијања листе пројеката',
    DbRetrievePagedProjectDocuments: 'Грешка приликом добијања листе докумената',
    DbRetrieveProjectDocument: 'Грешка приликом добијања документа. Захтевани документ не постоји',
    DbRetrieveProjectDocuments: 'Грешка приликом добијања докумената пројеката',
    DbProjectCreate: 'Грешка приликом креирања пројекта',
    DbProjectPhaseStatusUpdate: 'Грешка приликом ажурирања статуса фазе',
    DbProjectPhaseUpdate: 'Грешка приликом ажурирања фазе',
    DbRetrieveProject: 'Грешка приликом добијања пројекта',
    DbRetrieveForm: 'Грешка приликом добијања обрасца',
    DbCreateProjectForm: 'Грешка приликом креирања обрасца пројекта',
    DbSubmitProjectForm: 'Грешка приликом ажурирања обрасца пројекта',
    DbEvaluateProjectForm: 'Грешка приликом оцењивања обрасца пројекта',
    DbRetrieveProjectForm: 'Грешка приликом добијања обрасца пројекта',
    DbUploadProjectDocument: 'Грешка приликом додавања документа',
    DbUpdateProjectDocumentRevision: 'Грешка приликом ажурирања заштићеног линка',
    DbRetrieveProjectPhases: 'Грешка приликом добијања етапа пројекта',
    DbRetrieveProjectOrganizations: 'Грешка приликом добијања организација',
    DbSetProjectOrganizations: 'Грешка приликом ажурирања организација',
    DbAddProjectOrganziationInvalidState: 'Грешка приликом додавања организације. Организација већ постоји',
    DbRemoveProjectOrganziationInvalidState: 'Грешка приликом брисања организације. Организација не постоји',
    DbRetrieveProjectLists: 'Грешка приликом добијања листе пројеката',
    DbRetrieveProjectList: 'Грешка приликом детаља листе пројеката',
    DbCreateProjectList: 'Грешка приликом слања листе комисији',
    DbAddProjectAppropriationInvalidState: 'Грешка приликом додавања апропријација. Апропријација већ постоји',
    DbRemoveProjectAppropriationInvalidState: 'Грешка приликом брисања апропријације. Апропријација не постоји',
    DbSetProjectAppropriations: 'Грешка приликом ажурирања апропријација',
    DbRetrieveProjectAppropriations: 'Грешка приликом добијања апропријација пројекта',
    DbRetrieveProjectFormData: 'Грешка приликом добијања података образаца',
    DbRetrieveProjectDocumentRevision: 'Грешка приликом добијања ревизије документа. Захтевани документ не постоји',
    DbUploadProjectDocumentRevision: 'Грешка приликом додавања ревизије документа',
    DbRetrieveProjectDocumentRevisions: 'Грешка приликом добијања ревизија документа',
    DbSetProjectDocumentDownload: 'Грешка приликом ажурирања информација о преузимању документа',
    DbRemoveProjectDocument: 'Грешка приликом брисања документа',
    DbRemoveProjectDocumentRevisions: 'Грешка приликом брисања ревизија документа',
    DbRetrieveFormsUsingDocument: 'Грешка приликом добијања образаца који користе документ',
    DbRetrieveProjectSuccessKeyIndicators: 'Грешка приликом добијања КПУ података',
    DbRetrieveProjectListReport: 'Грешка приликом добијања листе пројеката за израду извештаја',
    DbRetrieveProjectSummaryReport: 'Грешка приликом добијања сумарне листе пројеката за израду извештаја',
    DbRetrieveProjectsRealizedReport: 'Грешка приликом добијања реализованих пројеката за израду извештаја',
    DbRetrieveProjectsInRealizationReport: 'Грешка приликом добијања пројеката у реализацији за израду извештаја',
    DbRetrieveProjectsBoardAcceptedReport: 'Грешка приликом добијања пројеката одобрених од комисије',
    // tran errors
    TranUploadProjectDocument: 'Трансакциона грешка приликом додавања документа',
    TranUpdateProjectDocumentRevision: 'Трансакциона грешка приликом ажурирања заштићеног линка',
    TranUnCreateProject: 'Трансакциона грешка приликом креирања пројекта',
    TranUnUpdateProject: 'Трансакциона грешка приликом ажурирања пројекта',
    TranExistsProjectCode: 'Пројекат са унетим радним називом већ постоји',
    // //reporting
    // validations
    InvalidExportFormat: 'Формат извоза није валидан',
    // unknown errors
    UnExportForm: 'Непозната грешка приликом извоза',
    // //registry organizations
    // validations
    DuplicateRegistryOrganization: 'Пронађен дупли идентификатор организације',
    EmptyRegistryImportOrganizationPayload: 'Захтев за импортовање шифарника организација није валидан',
    // unknown errors
    UnImportRegistryOrganization: 'Непозната грешка приликом импортовања шифарника организација',
    UnRetrievePagedRegistryOrganization: 'Непозната грешка приликом добијања шифарника организација',
    // db errors
    DbRetrievePagedRegistryOrganization: 'Грешка приликом добијања шифарника организација',
    DbImportRegistryOrganizationInvalidState: 'Грешка приликом импортовања шифарника организација',
    DbImportRegistryOrganization: 'Грешка приликом импортовања шифарника организација',
    // //registry treasury branch
    // validations
    DuplicateRegistryTreasuryBranch: 'Пронађен дупли идентификатор филијале трезора',
    EmptyImportRegistryTreasuryBranchPayload: 'Захтев за импортовање шифарника филијала трезора није валидан',
    // unknown errors
    UnRetrievePagedRegistryTreasuryBranch: 'Непозната грешка приликом добијања шифарника филијала трезора',
    UnImportRegistryTreasuryBranch: 'Непозната грешка приликом импортовања шифарника филијала трезора',
    UnRetrieveRegistryTreasuryBranch: 'Непозната грешка приликом добијања филијале трезора',
    UnRetrieveRegistryTreasuryBranches: 'Непозната грешка приликом добијања шифарника филијала трезора',
    // db errors
    DbImportRegistryTreasuryBranch: 'Грешка приликом импортовања шифарника филијала трезора',
    DbImportRegistryTreasuryBranchInvalidState: 'Грешка приликом импортовања шифарника филијала трезора',
    DbRetrieveRegistryTreasuryBranch: 'Грешка приликом добијања филијале трезора',
    DbRetrieveRegistryTreasuryBranches: 'Грешка приликом добијања шифарника филијала трезора',
    // //registry appropriations
    // validations
    DuplicateRegistryAppropriation: 'Пронађен дупли идентификатор апропријације',
    EmptyRegistryImportAppropriationPayload: 'Захтев за импортовање шифарника апропријација није валидан',
    // unknown errors
    UnImportRegistryAppropriation: 'Непозната грешка приликом импортовања шифарника апропријација',
    UnRetrieveRegistryAppropriations: 'Непозната грешка приликом добијања шифарника апропријација',
    // db errors
    DbImportRegistryAppropriationInvalidState: 'Грешка приликом импортовања шифарника апропријација',
    DbImportRegistryAppropriation: 'Грешка приликом импортовања шифарника апропријација',
    DbRetrieveRegistryAppropriations: 'Грешка приликом добијања шифарника апропријација',
    // //security organizations
    // validations
    InvalidOrganizationPermission: 'Корисник нема овлашћења за организацију',
    EmptyRetrieveRegistrationRequestBody: 'Захтев за добијање организација није валидан',
    EmptyResolveRegistrationRequestBody: 'Захтев за обраду регистрација није валидан',
    EmptyUpdateRegistrationMaxAmountBody: 'Захтев за ажурирањем максималног износа на организацији није валидан',
    EmptyUpdateRegistrationBody: 'Захтев за ажурирањем организације није валидан',
    AlreadySubmittedRegistration: 'Организација је већ регистрована',
    InvalidRegistrationBudgetUserId: 'ЈБКЈС организације се не подудара',
    InvalidRegistrationStatus: 'Статус регистрације није валидан. Мора бити у току',
    RegistrationConfirmationMail: 'Грешка приликом слања регистрационог маила',
    ForbiddenOrganizationRegistration: 'Регистрација није дозвољена',
    // fluent  validation
    InvalidOrganizationIdValidation: 'Идентификатор организације није валидан',
    InvalidOrganizationAdminNameValidation: 'Име администратора није валидно',
    InvalidOrganizationAdminIdentityNumberValidation: 'Број идентификационе исправе администратора није валидан',
    InvalidOrganizationAdminEmailValidation: 'Адреса електронске поште администратора није валидна',
    InvalidOrganizationAdminPhoneNumberValidation: 'Број телефона администратора није валидан',
    InvalidRegistrationTokenValidation: 'Токен није валидан',
    InvalidOrganizationRequestRespondValidation: 'Одговор захтева није валидан',
    InvalidOrganizationRequestCommentValidation: 'Коментар није валидан',
    InvalidOrganizationMaxAmountValidation: 'Максимални износ није валидан',
    InvalidOrganizationAdminLoginValidation: 'Корисничко име администратора није валидно',
    InvalidOrganizationEmailValidation: 'Адреса електронске поште није валидна',
    InvalidOrganizationPhoneNumberValidation: 'Број телефона није валидан',
    InvalidSupportEmailsValidation: 'Адреса електронске поште за подршку није валидна',
    InvalidSupportPhoneNumbersValidation: 'Број телефона за подршку није валидан',
    ExceededSupportEmailsLimitValidation: 'Прекорачен дозвољени број Емаил адреса за подршку. Дозвољене три Емаил адресе',
    ExceededSupportPhoneNumbersLimitValidation: 'Прекорачен дозвољени број телефона за подршку. Дозвољена три броја телефона',
    EmptyOrganizationNameShortValidation: 'Скраћени назив је обавезан податак',
    InvalidOrganizationNameShortLengthValidation: 'Дужина скраћеног назива није валидна',
    InvalidOrganizationNameShortValidation: 'Скраћени назив може садржати само слова',
    // unknown errors
    UnDecryptRegistrationToken: 'Непозната грешка приликом декрипције токена',
    UnApproveRegistrationRequest: 'Непозната грешка приликом одобравања регистрације',
    UnCancelRegistrationRequest: 'Непозната грешка приликом отказивања регистрације',
    UnCreateRegistrationRequest: 'Непозната грешка приликом креирања регистрације',
    UnUpdateRegistrationRequest: 'Непозната грешка приликом ажурирања регистрације',
    UnValidateRegistration: 'Непозната грешка приликом добијања регистрације',
    UnRetrievePagedRegistration: 'Непозната грешка приликом добијања регистрација',
    UnRetrieveRegistration: 'Непозната грешка приликом добијања регистрације',
    UnRetrieveRegistrationRequest: 'Непозната грешка приликом добијања регистрација',
    UnUpdateRegistrationMaxAmount: 'Непозната грешка приликом ажурирања максималног износа на организацији',
    UnUpdateRegistration: 'Непозната грешка приликом ажурирања организације',
    // db errors
    DbRetrieveBudgetUser: 'Грешка приликом добијања КЈС',
    DbRetrievePagedOrganization: 'Грешка приликом добијања организација',
    DbCreateRegistrationRequest: 'Грешка приликом креирања регистрација',
    DbRetrieveRegistration: 'Грешка приликом добијања регистрације',
    DbRetrieveTreasuryBranch: 'Грешка приликом добијања филијале трезора',
    DbDecryptRegistrationToken: 'Грешка приликом декрипције токена',
    DbApproveRegistrationRequest: 'Грешка приликом одобравања регистрације',
    DbCreateInitialUser: 'Грешка приликом креирања иницијалног корисника организације',
    DbCancelRegistrationRequest: 'Грешка приликом отказивања регистрације',
    DbUpdateRegistrationRequest: 'Грешка приликом ажурирања регистрације',
    DbUpdateRegistrationMaxAmount: 'Грешка приликом ажурирања максималног износа на организацији',
    DbUpdateRegistration: 'Грешка приликом ажурирања организације',
    // tran errors
    TranUnApproveRegistration: 'Грешка приликом одобравања регистрације',
    TranUnRegistrationUpdate: 'Грешка приликом ажурирања регистрације',
    TranCreateInitialUserLoginExists: 'Корисничко име већ постоји',
    TranCreateInitialUserRoleInvalid: 'Корисниче улоге иницијалног корисника није валидна',
    TranCreateInitialUser: 'Грешка приликом креирања иницијалног корисника организације',
    // //security claims
    // validations
    InvalidRoleClaims: 'Није могуће валидирати сва овлашћења за улогу',
    InvalidRole: 'Улога није валидна',
    UpdateSystemRole: 'Системска улога не може бити ажурирана',
    DeleteSystemRole: 'Системска улога не може бити обрисана',
    DeleteRole: 'Улога не може бити обрисана ако припада неком кориснику',
    // fluent validations
    InvalidRoleIdValidation: 'Идентификатор улоге није валидан',
    InvalidRoleNameValidation: 'Назив улоге није валидан',
    InvalidRoleDescriptionValidation: 'Опис улоге није валидан',
    InvalidClaimNameValidation: 'Назив овлашћења није валидан',
    InvalidClaimsValidation: 'Овлашћења нису валидна',
    // unknown errors
    UnCreateRole: 'Непозната грешка приликом креирања улоге',
    UnUpdateRole: 'Непозната грешка приликом ажурирања улоге',
    UnDeleteRole: 'Непозната грешка приликом брисања улоге',
    UnClaimsRetrieve: 'Непозната грешка приликом добијања овлашћења',
    UnRolesRetrieve: 'Непозната грешка приликом добијања улога',
    UnRetrieveRole: 'Непозната грешка приликом добијања улоге',
    // db errors
    DbCreateRole: 'Грешка приликом креирања улоге',
    DbCreateRoleInvalidState: 'Грешка приликом креирања улоге. Улога са датим називом већ постоји',
    DbUpdateRole: 'Грешка приликом ажурирања улоге',
    DbUpdateRoleInvalidState: 'Грешка приликом ажурирања улоге. Улога са датим називом већ постоји',
    DbDeleteRole: 'Грешка приликом брисања улоге',
    DbDeleteRoleInvalidState: 'Грешка приликом брисања улоге. Вероватно улога припада неком кориснику',
    DbRetrieveUserClaims: 'Грешка приликом добијања корисничких овлашћења',
    DbRetrieveRoles: 'Грешка приликом добијања улога',
    DbRetrieveRole: 'Грешка приликом добијања улоге',
    // tran errors
    TranUnCreateRole: 'Грешка приликом креирања улоге',
    TranUnUpdateRole: 'Грешка приликом ажурирања улоге',
    TranUnDeleteRole: 'Грешка приликом брисања улоге',
    TranCreateRole: 'Улога са датим називом већ постоји',
    TranUpdateRole: 'Невалидан идентификатор улоге',
    TranDeleteRole: 'Улога припада неком кориснику и није је могуће обрисати',
    TranCreateRoleClaims: 'Грешка приликом креирања корисничких овлашћења',
    TranDeleteRoleClaims: 'Грешка приликом ажурирања корисничких овлашћења',
    // //security users
    // validations
    InvalidUser: 'Корисник није пронађен',
    InvalidUserPassword: 'Корисничко име или лозинка нису исправни',
    InvalidUserAccess: 'Корисничко име или лозинка нису исправни или корисник није у активном статусу',
    InvalidRefreshToken: 'Токен је навалидан или опозван',
    InactiveUser: 'Корисник није активан',
    RevokedUser: 'Корисник је опозван',
    DisabledUser: 'Корисник је деактивиран',
    UpdateUserItselfStatus: 'Лично додељивање овлашћења није могуће',
    UpdateDisabledUserStatus: 'Покушај ажурирања деактивираног корисника',
    UpdateRevokedUserStatus: 'Покушај ажурирања опозваног корисника',
    UpdateInactiveUserStatus: 'Покушај ажурирања неактивног корисника',
    UpdateSameUserStatus: 'Покушај ажурирања корисника са статусом који већ поседује',
    AlreadyActivatedUser: 'Корисник је већ активиран',
    DeactivatedUser: 'Корисник је деактивиран',
    MismatchActivationTokenUser: 'Активациони токен није валидан за корисника',
    MismatchResetTokenUser: 'Ресет токен није валидан за корисника',
    PasswordResetUserStatus: 'Није могуће ресетовати лозинку неактивном кориснику',
    DuplicateUserLogin: 'Пронађено дупло корисничко име',
    InvalidLoginCharacters: 'Корисничко име не може бити празно или веће од 32 карактера',
    UpdateUserPasswordPermission: 'Само корисник сам себи може променити лозинку',
    UpdateUserProfilePermission: 'Само корисник сам себи може ажурирати профил',
    RetrieveUserPermission: 'Корисник нема овлашћења да види корисника',
    UpdateMultipleOrganizationUsers: 'Није могуће ажурирати кориснике из више организација',
    DuplicateUserTag: 'Пронађен дупли таг',
    ReachedUserTagsLimit: 'Прекорачен дозвољени број тагова по кориснику',
    InvalidUserTag: 'Кориснички таг није пронађен',
    UserActivationMail: 'Грешка приликом слања активационог маила',
    UserPasswordResetMail: 'Грешка приликом слања маила за верификацију нове локације корисника',
    ReachedFailedLoginAttemptCount: 'Корисник је закључан услед прекораченог броја неуспешних пријава',
    InvalidActivationToken: 'Активациони токен није валидан',
    InvalidResetToken: 'Токен за промену лозинке није валидан',
    ExistsMergeUser: 'Корисник је већ спојен',
    InvalidMergedUser: 'Није могуће асоцирати тренутно пријављеног корисника',
    InvalidUnmergedUser: 'Није могуће одвојити тренутно улогованог корисника',
    BlockedUserLocation: 'Препозната је непозната локација. Пријава у систем није могућа док се нова локација не верификује. Детаљи су послати на Вашу емаил адресу',
    BlockedUser: 'Корисник је блокиран услед сумњивих активности. Обратите се администратору система',
    // fluent validatons
    InvalidPasswordLengthValidation: 'Број карактера лозинке није исправан',
    InvalidPasswordNumbersValidation: 'Лозинка мора садржати број',
    InvalidPasswordUppercaseValidation: 'Лозинка мора садржати велико слово',
    InvalidPasswordSymbolsValidation: 'Лозинка мора садржати симболе',
    InvalidPasswordValidation: 'Лозинка није валидна',
    InvalidNewPasswordValidation: 'Потврда лозинке није валидна',
    InvalidUserStatusValidation: 'Статус није валидан',
    InvalidUserLoginLengthValidation: 'Дужина корисничког имена није валидна',
    InvalidUserLoginValidation: 'Корисничко име није валидно',
    InvalidUserLoginPrefixValidation: 'Корисничко име мора почети са словом или бројем',
    InvalidUserLoginSufixValidation: 'Корисничко име мора се завршити са словом или бројем',
    InvalidUserLoginCharacterValidation: 'Корисничко име садржи недозвољене карактере',
    InvalidUserNameLengthValidation: 'Дужина имена није валидна',
    InvalidUserNameValidation: 'Име није валидно',
    InvalidUserNamePrefixValidation: 'Име мора почети са словом или бројем',
    InvalidUserNameSufixValidation: 'Име мора се завршити са словом или бројем',
    InvalidUserNameCharacterValidation: 'Име садржи недозвољене карактере',
    InvalidUserEmailValidation: 'Електронска пошта није валидна',
    InvalidUserRoleIdValidation: 'Идентификатор улоге није валидан',
    InvalidUserCreatedDateValidation: 'Датум креирања није валидан',
    // unknown errors
    UnUpdateUserPassword: 'Непозната грешка приликом ажурирања лозинке',
    UnUpdateUserStatus: 'Непозната грешка приликом ажурирања статуса корисника',
    UnUpdateUser: 'Непозната грешка приликом ажурирања корисника',
    UnUpdateUserProfile: 'Непозната грешка приликом ажурирања профила корисника',
    UnCreateAccessToken: 'Непозната грешка приликом креирања приступног токена',
    UnRefreshAccessToken: 'Непозната грешка приликом креирања обновљивог токена',
    UnRetrievePagedUsers: 'Непозната грешка приликом добијања корисника',
    UnCreateUser: 'Непозната грешка приликом креирања корисника',
    UnRetrieveUser: 'Непозната грешка приликом добијања корисника',
    UnRetrieveUniqueUserLogin: 'Непозната грешка приликом добијања јединственог корисничког имена',
    UnCreateActivationToken: 'Непозната грешка приликом креирања активационог токена',
    UnCreateResetToken: 'Непозната грешка приликом креирања ресет токена',
    UnActivateUser: 'Непозната грешка приликом активација корисника',
    UnValidateActivationToken: 'Непозната грешка приликом валидације активационог корисника',
    UnValidateResetToken: 'Непозната грешка приликом валидације токена за промену лозинке',
    UnResetUserPassword: 'Непозната грешка приликом ресетовања лозинке корисника',
    UnSetUserTag: 'Непозната грешка приликом сетовања тага',
    UnSetSelectonTag: 'Непозната грешка приликом сетовање селекције',
    UnMergeUser: 'Непозната грешка приликом спајања корисника',
    UnUnmergeUser: 'Непозната грешка приликом одвајања спојених корисника',
    UnRetrieveMergedUsers: 'Непозната грешка приликом добијања спојених корисника',
    UnRetrieveMergedUser: 'Непозната грешка приликом добијања спојеног корисника',
    UnUpdateUserLastLogoutDate: 'Непозната грешка приликом ажурирања последње одјаве корисника',
    // db errors
    DbRetrieveUser: 'Грешка приликом добијања корисника',
    DbRetrievePagedUsers: 'Грешка приликом добијања корисника',
    DbUpdateUserPassword: 'Грешка приликом ажурирања лозинке',
    DbCreateUser: 'Грешка приликом креирања корисника',
    DbCreateUserInvalidState: 'Кориснички налог заузет',
    DbUpdateUserStatus: 'Грешка приликом ажурирања статуса корисника',
    DbUpdateUser: 'Грешка приликом ажурирања корисника',
    DbUpdateUserProfile: 'Грешка приликом ажурирања профила корисника',
    DbUpdateUserLastLoginDate: 'Грешка приликом ажурирања последње пријаве корисника',
    DbUpdateUserLastLogoutDate: 'Грешка приликом ажурирања последње одјаве корисника',
    DbUpdateUserLastRefreshTokenDate: 'Грешка приликом ажурирања датума последњег обновљивог токена',
    DbRetrieveUserFromActivationToken: 'Грешка приликом добијања корисника из активационог токена',
    DbActivateUser: 'Грешка приликом активирања корисника',
    DbUpdateUserInvalidState: 'Грешка приликом ажурирања корисника',
    DbUpdateUserStatusInvalidState: 'Грешка приликом ажурирања статуса корисника',
    DbRetrieveUsers: 'Грешка приликом добијања корисника',
    DbManageUserTagInvalidState: 'Грешка приликом ажурирања тагова',
    DbRetrieveTaggedUsers: 'Грешка приликом добијања тагованих корисника',
    DbMergeUser: 'Грешка приликом спајања корисника',
    DbUnmergeUser: 'Грешка приликом одвајања спојених корисника',
    DbRetrieveMergedUsers: 'Грешка приликом добијања спојених корисника',
    DbRetrieveMergedUser: 'Грешка приликом добијања спојеног корисника',
    // tran errors
    TranUnCreateUser: 'Грешка приликом креирања корисника',
    TranUnUpdateUser: 'Грешка приликом ажурирања корисника',
    TranUnUpdateUserProfile: 'Грешка приликом ажурирања профила корисника',
    TranUserLoginExists: 'Корисничко име већ постоји',
    TranCreateUser: 'Грешка приликом креирања корисника',
    TranUpdateUserHigherPrivileges: 'Грешка приликом ажурирања корисника са вишим овлашћењима',
    TranUpdateUserForbiddenPermissions: 'Грешка приликом ажурирања корисника за забрањеним овлашћењима',
    TranRetrieveUserId: 'Грешка приликом добијања корисника по идентификатору',
    TranUserLimit: 'Прекорачен је дозвољени број корисника по организацији',
    TranDuplicateUserLogin: 'Пронађено дупло корисничко име',
    TranOrganizationNameShortExists: 'Скраћен назив већ постоји',
    // project document
    RetrieveImportantProjectDocument: 'Није унет документ типа "КППЗ одлука Владе РС"',
    ErrProjectIdentificationNewCostDocument: 'Нису пронађена документа о изворима',
    ErrProjectIdentificationFinacialSourceDocument: 'Није унет документ "Писмо о намерама" везан за тачку 4.6',
    ErrProjectIdentificationEstimateCapitalRetrieve: 'Ако није унет коментар у тачки 4.1 потребно је приложити документ ПредлогКП - Приказ извора процене укупних трошкова капиталног пројекта',
    ErrProjectIdentificationFeasibilitySourceDocument: 'Нису унетa документa "Размена елктронске поште" или "Писмо о намерама спољашњег финансијера" везани за тачку 4.2',
    ErrProjectIdentificationIsdaconDocument: 'Није унета оцена из ИЗДАКОН-а',
    ErrProjectPreparednessRealizationPlanDocumentRetrieve: 'Није унет документ о оквирном плану реализације иако је у обрасцу наведено да план постоји.',
    ErrProjectCorrectionDocument: 'Корекцију мора да прате документа "Oбразложење разлога одступања" и Доказ за наводе у образложењу"',
    ErrProjectIdentificationMfinCommentMissing: 'МФИН коментар није унет',
    // Form 3 validations
    O3ScopeChoiceEmpty: 'Кохерентан са циљевима пројекта - морате изабрати Да или Не',
    O3ScopeChoice2Empty: 'Сагласан са циљевима развојних планова - морате изабрати Да или Не',
    O3ScopeChoice3Empty: 'Усаглашен са регулаторним и законским оквиром - морате изабрати Да или Не',
    O3ScopeChoice4Empty: 'Има оквирни план реализације - морате изабрати Да или Не',
    O3ScopeChoice5Empty: 'Има идентификоване клијенте/купце или кориснике пројекта - морате изабрати Да или Не',
    O3ScopeChoice6Empty: 'Има припремљену пројектно-тендерску документацију - морате изабрати Да или Не',
    O3ScopeChoice7Empty: 'Има идентификоване критичне тачке пројекта - морате изабрати Да или Не',
    O3ScopeChoice8Empty: 'Има идентификоване потенцијалне ризике и проблеме - морате изабрати Да или Не',
    O3ScopeChoice9Empty: 'Има дефинисане механизме за решавање/ублажавање потенцијалних ризика/проблема - морате изабрати Да или Не',
    O3ScopeChoice10Empty: 'Има дефинисане људске/институционалне или материјално/техничке ресурсе потребне за реализацију пројекта - морате изабрати Да или Не',
    O3ScopeChoice11Empty: 'Има Предходну студију изводљивости/оправданости - морате изабрати Да или Не',
    O3ScopeChoice12Empty: 'Има јасно дефинисане улоге и одговорности - морате изабрати Да или Не',
    O3ProcurementChoiceEmpty: 'Набавка услуга - морате изабрати Да или Не',
    O3ProcurementChoice2Empty: 'Набавка опреме - морате изабрати Да или Не',
    O3ProcurementChoice3Empty: 'Инфраструктурни пројекти/набавка непокретности - морате изабрати Да или Не',
    ProcurementChoiceActivityChoiceError31: 'У случају да је Набавка услуга Да (тачка 2), сва поља у тачки 3.1 морају бити попуњена',
    ProcurementChoiceActivityChoiceError32: 'У случају да је Набавка опреме Да (тачка 2), сва поља у тачки 3.2 морају бити попуњена',
    ProcurementChoiceActivityChoiceError33: 'У случају да је Инфраструктурни пројекти/набавка непокретности Да (тачка 2), сва поља у тачки 3.3 морају бити попуњена'

  },
  fields: {
    NewPassword: 'Нова лозинка'
  },
  formIdea: {
    title: 'Oбразац за прелиминарну оцену пројектне идеје'
  }
}
